/**
 * FormValidation (https://formvalidation.io)
 * The best validation library for JavaScript
 * (c) 2013 - 2023 Nguyen Huu Phuoc <me@phuoc.ng>
 *
 * @license https://formvalidation.io/license
 * @package @form-validation/bundle
 * @version 2.4.0
 */

!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? t(exports)
    : 'function' == typeof define && define.amd
      ? define(['exports'], t)
      : t(
          ((e =
            'undefined' != typeof globalThis
              ? globalThis
              : e || self).FormValidation = {}),
        );
})(this, function (e) {
  'use strict';
  var t,
    n = { exports: {} },
    i = {};
  n.exports = (function () {
    if (t) return i;
    t = 1;
    var e = {
        luhn: function (e) {
          for (
            var t = e.length,
              n = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
              ],
              i = 0,
              r = 0;
            t--;

          )
            ((r += n[i][parseInt(e.charAt(t), 10)]), (i = 1 - i));
          return r % 10 == 0 && r > 0;
        },
        mod11And10: function (e) {
          for (var t = e.length, n = 5, i = 0; i < t; i++)
            n = (((2 * (n || 10)) % 11) + parseInt(e.charAt(i), 10)) % 10;
          return 1 === n;
        },
        mod37And36: function (e, t) {
          void 0 === t && (t = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ');
          for (
            var n = e.length, i = t.length, r = Math.floor(i / 2), o = 0;
            o < n;
            o++
          )
            r = (((2 * (r || i)) % (i + 1)) + t.indexOf(e.charAt(o))) % i;
          return 1 === r;
        },
        mod97And10: function (e) {
          for (
            var t = (function (e) {
                return e
                  .split('')
                  .map(function (e) {
                    var t = e.charCodeAt(0);
                    return t >= 65 && t <= 90 ? t - 55 : e;
                  })
                  .join('')
                  .split('')
                  .map(function (e) {
                    return parseInt(e, 10);
                  });
              })(e),
              n = 0,
              i = t.length,
              r = 0;
            r < i - 1;
            ++r
          )
            n = (10 * (n + t[r])) % 97;
          return (n += t[i - 1]) % 97 == 1;
        },
        verhoeff: function (e) {
          for (
            var t = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
                [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
                [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
                [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
                [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
                [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
                [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
                [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
                [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
              ],
              n = [
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
                [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
                [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
                [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
                [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
                [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
                [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
              ],
              i = e.reverse(),
              r = 0,
              o = 0;
            o < i.length;
            o++
          )
            r = t[r][n[o % 8][i[o]]];
          return 0 === r;
        },
      },
      n = (function () {
        function e(e, t) {
          ((this.fields = {}),
            (this.elements = {}),
            (this.ee = {
              fns: {},
              clear: function () {
                this.fns = {};
              },
              emit: function (e) {
                for (var t = [], n = 1; n < arguments.length; n++)
                  t[n - 1] = arguments[n];
                (this.fns[e] || []).map(function (e) {
                  return e.apply(e, t);
                });
              },
              off: function (e, t) {
                if (this.fns[e]) {
                  var n = this.fns[e].indexOf(t);
                  n >= 0 && this.fns[e].splice(n, 1);
                }
              },
              on: function (e, t) {
                (this.fns[e] = this.fns[e] || []).push(t);
              },
            }),
            (this.filter = {
              filters: {},
              add: function (e, t) {
                (this.filters[e] = this.filters[e] || []).push(t);
              },
              clear: function () {
                this.filters = {};
              },
              execute: function (e, t, n) {
                if (!this.filters[e] || !this.filters[e].length) return t;
                for (
                  var i = t, r = this.filters[e], o = r.length, a = 0;
                  a < o;
                  a++
                )
                  i = r[a].apply(i, n);
                return i;
              },
              remove: function (e, t) {
                this.filters[e] &&
                  (this.filters[e] = this.filters[e].filter(function (e) {
                    return e !== t;
                  }));
              },
            }),
            (this.plugins = {}),
            (this.results = new Map()),
            (this.validators = {}),
            (this.form = e),
            (this.fields = t));
        }
        return (
          (e.prototype.on = function (e, t) {
            return (this.ee.on(e, t), this);
          }),
          (e.prototype.off = function (e, t) {
            return (this.ee.off(e, t), this);
          }),
          (e.prototype.emit = function (e) {
            for (var t, n = [], i = 1; i < arguments.length; i++)
              n[i - 1] = arguments[i];
            return (
              (t = this.ee).emit.apply(
                t,
                (function (e, t, n) {
                  if (n || 2 === arguments.length)
                    for (var i, r = 0, o = t.length; r < o; r++)
                      (!i && r in t) ||
                        (i || (i = Array.prototype.slice.call(t, 0, r)),
                        (i[r] = t[r]));
                  return e.concat(i || Array.prototype.slice.call(t));
                })([e], n, !1),
              ),
              this
            );
          }),
          (e.prototype.registerPlugin = function (e, t) {
            if (this.plugins[e])
              throw new Error('The plguin '.concat(e, ' is registered'));
            return (t.setCore(this), t.install(), (this.plugins[e] = t), this);
          }),
          (e.prototype.deregisterPlugin = function (e) {
            var t = this.plugins[e];
            return (t && t.uninstall(), delete this.plugins[e], this);
          }),
          (e.prototype.enablePlugin = function (e) {
            var t = this.plugins[e];
            return (t && t.enable(), this);
          }),
          (e.prototype.disablePlugin = function (e) {
            var t = this.plugins[e];
            return (t && t.disable(), this);
          }),
          (e.prototype.isPluginEnabled = function (e) {
            var t = this.plugins[e];
            return !!t && t.isPluginEnabled();
          }),
          (e.prototype.registerValidator = function (e, t) {
            if (this.validators[e])
              throw new Error('The validator '.concat(e, ' is registered'));
            return ((this.validators[e] = t), this);
          }),
          (e.prototype.registerFilter = function (e, t) {
            return (this.filter.add(e, t), this);
          }),
          (e.prototype.deregisterFilter = function (e, t) {
            return (this.filter.remove(e, t), this);
          }),
          (e.prototype.executeFilter = function (e, t, n) {
            return this.filter.execute(e, t, n);
          }),
          (e.prototype.addField = function (e, t) {
            var n = Object.assign({}, { selector: '', validators: {} }, t);
            return (
              (this.fields[e] = this.fields[e]
                ? {
                    selector: n.selector || this.fields[e].selector,
                    validators: Object.assign(
                      {},
                      this.fields[e].validators,
                      n.validators,
                    ),
                  }
                : n),
              (this.elements[e] = this.queryElements(e)),
              this.emit('core.field.added', {
                elements: this.elements[e],
                field: e,
                options: this.fields[e],
              }),
              this
            );
          }),
          (e.prototype.removeField = function (e) {
            if (!this.fields[e])
              throw new Error(
                'The field '.concat(
                  e,
                  ' validators are not defined. Please ensure the field is added first',
                ),
              );
            var t = this.elements[e],
              n = this.fields[e];
            return (
              delete this.elements[e],
              delete this.fields[e],
              this.emit('core.field.removed', {
                elements: t,
                field: e,
                options: n,
              }),
              this
            );
          }),
          (e.prototype.validate = function () {
            var e = this;
            return (
              this.emit('core.form.validating', { formValidation: this }),
              this.filter
                .execute('validate-pre', Promise.resolve(), [])
                .then(function () {
                  return Promise.all(
                    Object.keys(e.fields).map(function (t) {
                      return e.validateField(t);
                    }),
                  ).then(function (t) {
                    switch (!0) {
                      case -1 !== t.indexOf('Invalid'):
                        return (
                          e.emit('core.form.invalid', { formValidation: e }),
                          Promise.resolve('Invalid')
                        );
                      case -1 !== t.indexOf('NotValidated'):
                        return (
                          e.emit('core.form.notvalidated', {
                            formValidation: e,
                          }),
                          Promise.resolve('NotValidated')
                        );
                      default:
                        return (
                          e.emit('core.form.valid', { formValidation: e }),
                          Promise.resolve('Valid')
                        );
                    }
                  });
                })
            );
          }),
          (e.prototype.validateField = function (e) {
            var t = this,
              n = this.results.get(e);
            if ('Valid' === n || 'Invalid' === n) return Promise.resolve(n);
            this.emit('core.field.validating', e);
            var i = this.elements[e];
            if (0 === i.length)
              return (
                this.emit('core.field.valid', e),
                Promise.resolve('Valid')
              );
            var r = i[0].getAttribute('type');
            return 'radio' === r || 'checkbox' === r || 1 === i.length
              ? this.validateElement(e, i[0])
              : Promise.all(
                  i.map(function (n) {
                    return t.validateElement(e, n);
                  }),
                ).then(function (n) {
                  switch (!0) {
                    case -1 !== n.indexOf('Invalid'):
                      return (
                        t.emit('core.field.invalid', e),
                        t.results.set(e, 'Invalid'),
                        Promise.resolve('Invalid')
                      );
                    case -1 !== n.indexOf('NotValidated'):
                      return (
                        t.emit('core.field.notvalidated', e),
                        t.results.delete(e),
                        Promise.resolve('NotValidated')
                      );
                    default:
                      return (
                        t.emit('core.field.valid', e),
                        t.results.set(e, 'Valid'),
                        Promise.resolve('Valid')
                      );
                  }
                });
          }),
          (e.prototype.validateElement = function (e, t) {
            var n = this;
            this.results.delete(e);
            var i = this.elements[e];
            if (this.filter.execute('element-ignored', !1, [e, t, i]))
              return (
                this.emit('core.element.ignored', {
                  element: t,
                  elements: i,
                  field: e,
                }),
                Promise.resolve('Ignored')
              );
            var r = this.fields[e].validators;
            this.emit('core.element.validating', {
              element: t,
              elements: i,
              field: e,
            });
            var o = Object.keys(r).map(function (i) {
              return function () {
                return n.executeValidator(e, t, i, r[i]);
              };
            });
            return this.waterfall(o)
              .then(function (r) {
                var o = -1 === r.indexOf('Invalid');
                n.emit('core.element.validated', {
                  element: t,
                  elements: i,
                  field: e,
                  valid: o,
                });
                var a = t.getAttribute('type');
                return (
                  ('radio' !== a && 'checkbox' !== a && 1 !== i.length) ||
                    n.emit(o ? 'core.field.valid' : 'core.field.invalid', e),
                  Promise.resolve(o ? 'Valid' : 'Invalid')
                );
              })
              .catch(function (r) {
                return (
                  n.emit('core.element.notvalidated', {
                    element: t,
                    elements: i,
                    field: e,
                  }),
                  Promise.resolve(r)
                );
              });
          }),
          (e.prototype.executeValidator = function (e, t, n, i) {
            var r = this,
              o = this.elements[e],
              a = this.filter.execute('validator-name', n, [n, e]);
            if (
              ((i.message = this.filter.execute(
                'validator-message',
                i.message,
                [this.locale, e, a],
              )),
              !this.validators[a] || !1 === i.enabled)
            )
              return (
                this.emit('core.validator.validated', {
                  element: t,
                  elements: o,
                  field: e,
                  result: this.normalizeResult(e, a, { valid: !0 }),
                  validator: a,
                }),
                Promise.resolve('Valid')
              );
            var s = this.validators[a],
              l = this.getElementValue(e, t, a);
            if (!this.filter.execute('field-should-validate', !0, [e, t, l, n]))
              return (
                this.emit('core.validator.notvalidated', {
                  element: t,
                  elements: o,
                  field: e,
                  validator: n,
                }),
                Promise.resolve('NotValidated')
              );
            this.emit('core.validator.validating', {
              element: t,
              elements: o,
              field: e,
              validator: n,
            });
            var d = s().validate({
              element: t,
              elements: o,
              field: e,
              l10n: this.localization,
              options: i,
              value: l,
            });
            if ('function' == typeof d.then)
              return d.then(function (i) {
                var a = r.normalizeResult(e, n, i);
                return (
                  r.emit('core.validator.validated', {
                    element: t,
                    elements: o,
                    field: e,
                    result: a,
                    validator: n,
                  }),
                  a.valid ? 'Valid' : 'Invalid'
                );
              });
            var c = this.normalizeResult(e, n, d);
            return (
              this.emit('core.validator.validated', {
                element: t,
                elements: o,
                field: e,
                result: c,
                validator: n,
              }),
              Promise.resolve(c.valid ? 'Valid' : 'Invalid')
            );
          }),
          (e.prototype.getElementValue = function (e, t, n) {
            var i = (function (e, t, n, i) {
              var r = (n.getAttribute('type') || '').toLowerCase(),
                o = n.tagName.toLowerCase();
              if ('textarea' === o) return n.value;
              if ('select' === o) {
                var a = n,
                  s = a.selectedIndex;
                return s >= 0 ? a.options.item(s).value : '';
              }
              if ('input' === o) {
                if ('radio' === r || 'checkbox' === r) {
                  var l = i.filter(function (e) {
                    return e.checked;
                  }).length;
                  return 0 === l ? '' : l + '';
                }
                return n.value;
              }
              return '';
            })(this.form, 0, t, this.elements[e]);
            return this.filter.execute('field-value', i, [i, e, t, n]);
          }),
          (e.prototype.getElements = function (e) {
            return this.elements[e];
          }),
          (e.prototype.getFields = function () {
            return this.fields;
          }),
          (e.prototype.getFormElement = function () {
            return this.form;
          }),
          (e.prototype.getLocale = function () {
            return this.locale;
          }),
          (e.prototype.getPlugin = function (e) {
            return this.plugins[e];
          }),
          (e.prototype.updateFieldStatus = function (e, t, n) {
            var i = this,
              r = this.elements[e],
              o = r[0].getAttribute('type');
            if (
              (('radio' === o || 'checkbox' === o ? [r[0]] : r).forEach(
                function (r) {
                  return i.updateElementStatus(e, r, t, n);
                },
              ),
              n)
            )
              'Invalid' === t &&
                (this.emit('core.field.invalid', e),
                this.results.set(e, 'Invalid'));
            else
              switch (t) {
                case 'NotValidated':
                  (this.emit('core.field.notvalidated', e),
                    this.results.delete(e));
                  break;
                case 'Validating':
                  (this.emit('core.field.validating', e),
                    this.results.delete(e));
                  break;
                case 'Valid':
                  (this.emit('core.field.valid', e),
                    this.results.set(e, 'Valid'));
                  break;
                case 'Invalid':
                  (this.emit('core.field.invalid', e),
                    this.results.set(e, 'Invalid'));
              }
            return this;
          }),
          (e.prototype.updateElementStatus = function (e, t, n, i) {
            var r = this,
              o = this.elements[e],
              a = this.fields[e].validators,
              s = i ? [i] : Object.keys(a);
            switch (n) {
              case 'NotValidated':
                (s.forEach(function (n) {
                  return r.emit('core.validator.notvalidated', {
                    element: t,
                    elements: o,
                    field: e,
                    validator: n,
                  });
                }),
                  this.emit('core.element.notvalidated', {
                    element: t,
                    elements: o,
                    field: e,
                  }));
                break;
              case 'Validating':
                (s.forEach(function (n) {
                  return r.emit('core.validator.validating', {
                    element: t,
                    elements: o,
                    field: e,
                    validator: n,
                  });
                }),
                  this.emit('core.element.validating', {
                    element: t,
                    elements: o,
                    field: e,
                  }));
                break;
              case 'Valid':
                (s.forEach(function (n) {
                  return r.emit('core.validator.validated', {
                    element: t,
                    elements: o,
                    field: e,
                    result: { message: a[n].message, valid: !0 },
                    validator: n,
                  });
                }),
                  this.emit('core.element.validated', {
                    element: t,
                    elements: o,
                    field: e,
                    valid: !0,
                  }));
                break;
              case 'Invalid':
                (s.forEach(function (n) {
                  return r.emit('core.validator.validated', {
                    element: t,
                    elements: o,
                    field: e,
                    result: { message: a[n].message, valid: !1 },
                    validator: n,
                  });
                }),
                  this.emit('core.element.validated', {
                    element: t,
                    elements: o,
                    field: e,
                    valid: !1,
                  }));
            }
            return this;
          }),
          (e.prototype.resetForm = function (e) {
            var t = this;
            return (
              Object.keys(this.fields).forEach(function (n) {
                return t.resetField(n, e);
              }),
              this.emit('core.form.reset', { formValidation: this, reset: e }),
              this
            );
          }),
          (e.prototype.resetField = function (e, t) {
            if (t) {
              var n = this.elements[e],
                i = n[0].getAttribute('type');
              n.forEach(function (e) {
                'radio' === i || 'checkbox' === i
                  ? (e.removeAttribute('selected'),
                    e.removeAttribute('checked'),
                    (e.checked = !1))
                  : (e.setAttribute('value', ''),
                    (e instanceof HTMLInputElement ||
                      e instanceof HTMLTextAreaElement) &&
                      (e.value = ''));
              });
            }
            return (
              this.updateFieldStatus(e, 'NotValidated'),
              this.emit('core.field.reset', { field: e, reset: t }),
              this
            );
          }),
          (e.prototype.revalidateField = function (e) {
            return this.fields[e]
              ? (this.updateFieldStatus(e, 'NotValidated'),
                this.validateField(e))
              : Promise.resolve('Ignored');
          }),
          (e.prototype.disableValidator = function (e, t) {
            if (!this.fields[e]) return this;
            var n = this.elements[e];
            return (
              this.toggleValidator(!1, e, t),
              this.emit('core.validator.disabled', {
                elements: n,
                field: e,
                formValidation: this,
                validator: t,
              }),
              this
            );
          }),
          (e.prototype.enableValidator = function (e, t) {
            if (!this.fields[e]) return this;
            var n = this.elements[e];
            return (
              this.toggleValidator(!0, e, t),
              this.emit('core.validator.enabled', {
                elements: n,
                field: e,
                formValidation: this,
                validator: t,
              }),
              this
            );
          }),
          (e.prototype.updateValidatorOption = function (e, t, n, i) {
            return (
              this.fields[e] &&
                this.fields[e].validators &&
                this.fields[e].validators[t] &&
                (this.fields[e].validators[t][n] = i),
              this
            );
          }),
          (e.prototype.setFieldOptions = function (e, t) {
            return ((this.fields[e] = t), this);
          }),
          (e.prototype.destroy = function () {
            var e = this;
            return (
              Object.keys(this.plugins).forEach(function (t) {
                return e.plugins[t].uninstall();
              }),
              this.ee.clear(),
              this.filter.clear(),
              this.results.clear(),
              (this.plugins = {}),
              this
            );
          }),
          (e.prototype.setLocale = function (e, t) {
            return ((this.locale = e), (this.localization = t), this);
          }),
          (e.prototype.waterfall = function (e) {
            return e.reduce(function (e, t) {
              return e.then(function (e) {
                return t().then(function (t) {
                  return (e.push(t), e);
                });
              });
            }, Promise.resolve([]));
          }),
          (e.prototype.queryElements = function (e) {
            var t = this.fields[e].selector
              ? '#' === this.fields[e].selector.charAt(0)
                ? '[id="'.concat(this.fields[e].selector.substring(1), '"]')
                : this.fields[e].selector
              : '[name="'.concat(e.replace(/"/g, '\\"'), '"]');
            return [].slice.call(this.form.querySelectorAll(t));
          }),
          (e.prototype.normalizeResult = function (e, t, n) {
            var i = this.fields[e].validators[t];
            return Object.assign({}, n, {
              message:
                n.message ||
                (i ? i.message : '') ||
                (this.localization &&
                this.localization[t] &&
                this.localization[t].default
                  ? this.localization[t].default
                  : '') ||
                'The field '.concat(e, ' is not valid'),
            });
          }),
          (e.prototype.toggleValidator = function (e, t, n) {
            var i = this,
              r = this.fields[t].validators;
            return (
              n && r && r[n]
                ? (this.fields[t].validators[n].enabled = e)
                : n ||
                  Object.keys(r).forEach(function (n) {
                    return (i.fields[t].validators[n].enabled = e);
                  }),
              this.updateFieldStatus(t, 'NotValidated', n)
            );
          }),
          e
        );
      })(),
      r = (function () {
        function e(e) {
          ((this.opts = e), (this.isEnabled = !0));
        }
        return (
          (e.prototype.setCore = function (e) {
            return ((this.core = e), this);
          }),
          (e.prototype.enable = function () {
            return ((this.isEnabled = !0), this.onEnabled(), this);
          }),
          (e.prototype.disable = function () {
            return ((this.isEnabled = !1), this.onDisabled(), this);
          }),
          (e.prototype.isPluginEnabled = function () {
            return this.isEnabled;
          }),
          (e.prototype.onEnabled = function () {}),
          (e.prototype.onDisabled = function () {}),
          (e.prototype.install = function () {}),
          (e.prototype.uninstall = function () {}),
          e
        );
      })(),
      o = function (e, t) {
        var n =
          e.matches ||
          e.webkitMatchesSelector ||
          e.mozMatchesSelector ||
          e.msMatchesSelector;
        return n
          ? n.call(e, t)
          : [].slice.call(e.parentElement.querySelectorAll(t)).indexOf(e) >= 0;
      },
      a = {
        call: function (e, t) {
          if ('function' == typeof e) return e.apply(this, t);
          if ('string' == typeof e) {
            var n = e;
            '()' === n.substring(n.length - 2) &&
              (n = n.substring(0, n.length - 2));
            for (
              var i = n.split('.'), r = i.pop(), o = window, a = 0, s = i;
              a < s.length;
              a++
            )
              o = o[s[a]];
            return void 0 === o[r] ? null : o[r].apply(this, t);
          }
        },
        classSet: function (e, t) {
          var n = [],
            i = [];
          (Object.keys(t).forEach(function (e) {
            e && (t[e] ? n.push(e) : i.push(e));
          }),
            i.forEach(function (t) {
              return (function (e, t) {
                t.split(' ').forEach(function (t) {
                  e.classList
                    ? e.classList.remove(t)
                    : (e.className = e.className.replace(t, ''));
                });
              })(e, t);
            }),
            n.forEach(function (t) {
              return (function (e, t) {
                t.split(' ').forEach(function (t) {
                  e.classList
                    ? e.classList.add(t)
                    : ' '
                        .concat(e.className, ' ')
                        .indexOf(' '.concat(t, ' ')) &&
                      (e.className += ' '.concat(t));
                });
              })(e, t);
            }));
        },
        closest: function (e, t) {
          for (var n = e; n && !o(n, t); ) n = n.parentElement;
          return n;
        },
        fetch: function (e, t) {
          return new Promise(function (n, i) {
            var r,
              o = Object.assign(
                {},
                { crossDomain: !1, headers: {}, method: 'GET', params: {} },
                t,
              ),
              a = Object.keys(o.params)
                .map(function (e) {
                  return ''
                    .concat(encodeURIComponent(e), '=')
                    .concat(encodeURIComponent(o.params[e]));
                })
                .join('&'),
              s = e.indexOf('?') > -1,
              l =
                'GET' === o.method
                  ? ''
                      .concat(e)
                      .concat(s ? '&' : '?')
                      .concat(a)
                  : e;
            if (o.crossDomain) {
              var d = document.createElement('script'),
                c = '___FormValidationFetch_'.concat(
                  Array(12)
                    .fill('')
                    .map(function (e) {
                      return Math.random().toString(36).charAt(2);
                    })
                    .join(''),
                  '___',
                );
              ((window[c] = function (e) {
                (delete window[c], n(e));
              }),
                (d.src = ''
                  .concat(l)
                  .concat(s ? '&' : '?', 'callback=')
                  .concat(c)),
                (d.async = !0),
                d.addEventListener('load', function () {
                  d.parentNode.removeChild(d);
                }),
                d.addEventListener('error', function () {
                  return i;
                }),
                document.head.appendChild(d));
            } else {
              var u = new XMLHttpRequest();
              (u.open(o.method, l),
                u.setRequestHeader('X-Requested-With', 'XMLHttpRequest'),
                'POST' === o.method &&
                  u.setRequestHeader(
                    'Content-Type',
                    'application/x-www-form-urlencoded',
                  ),
                Object.keys(o.headers).forEach(function (e) {
                  return u.setRequestHeader(e, o.headers[e]);
                }),
                u.addEventListener('load', function () {
                  n(JSON.parse(this.responseText));
                }),
                u.addEventListener('error', function () {
                  return i;
                }),
                u.send(
                  ((r = o.params),
                  Object.keys(r)
                    .map(function (e) {
                      return ''
                        .concat(encodeURIComponent(e), '=')
                        .concat(encodeURIComponent(r[e]));
                    })
                    .join('&')),
                ));
            }
          });
        },
        format: function (e, t) {
          var n = Array.isArray(t) ? t : [t],
            i = e;
          return (
            n.forEach(function (e) {
              i = i.replace('%s', e);
            }),
            i
          );
        },
        hasClass: function (e, t) {
          return e.classList
            ? e.classList.contains(t)
            : new RegExp('(^| )'.concat(t, '( |$)'), 'gi').test(e.className);
        },
        isValidDate: function (e, t, n, i) {
          if (isNaN(e) || isNaN(t) || isNaN(n)) return !1;
          if (e < 1e3 || e > 9999 || t <= 0 || t > 12) return !1;
          if (
            n <= 0 ||
            n >
              [
                31,
                e % 400 == 0 || (e % 100 != 0 && e % 4 == 0) ? 29 : 28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31,
              ][t - 1]
          )
            return !1;
          if (!0 === i) {
            var r = new Date(),
              o = r.getFullYear(),
              a = r.getMonth(),
              s = r.getDate();
            return (
              e < o ||
              (e === o && t - 1 < a) ||
              (e === o && t - 1 === a && n < s)
            );
          }
          return !0;
        },
        removeUndefined: function (e) {
          return e
            ? Object.entries(e).reduce(function (e, t) {
                var n = t[0],
                  i = t[1];
                return (void 0 === i || (e[n] = i), e);
              }, {})
            : {};
        },
      };
    return (
      (i.Plugin = r),
      (i.algorithms = e),
      (i.formValidation = function (e, t) {
        var i = Object.assign(
            {},
            { fields: {}, locale: 'en_US', plugins: {}, init: function (e) {} },
            t,
          ),
          r = new n(e, i.fields);
        return (
          r.setLocale(i.locale, i.localization),
          Object.keys(i.plugins).forEach(function (e) {
            return r.registerPlugin(e, i.plugins[e]);
          }),
          i.init(r),
          Object.keys(i.fields).forEach(function (e) {
            return r.addField(e, i.fields[e]);
          }),
          r
        );
      }),
      (i.utils = a),
      i
    );
  })();
  var r,
    o = n.exports,
    a = { exports: {} },
    s = {};
  a.exports = (function () {
    if (r) return s;
    r = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          return (
            (n.opts = e || {}),
            (n.validatorNameFilter = n.getValidatorName.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            this.core.registerFilter(
              'validator-name',
              this.validatorNameFilter,
            );
          }),
          (n.prototype.uninstall = function () {
            this.core.deregisterFilter(
              'validator-name',
              this.validatorNameFilter,
            );
          }),
          (n.prototype.getValidatorName = function (e, t) {
            return (this.isEnabled && this.opts[e]) || e;
          }),
          n
        );
      })(o.Plugin);
    return ((s.Alias = t), s);
  })();
  var l,
    d = a.exports,
    c = { exports: {} },
    u = {};
  c.exports = (function () {
    if (l) return u;
    l = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n() {
          var e = t.call(this, {}) || this;
          return (
            (e.elementValidatedHandler = e.onElementValidated.bind(e)),
            (e.fieldValidHandler = e.onFieldValid.bind(e)),
            (e.fieldInvalidHandler = e.onFieldInvalid.bind(e)),
            (e.messageDisplayedHandler = e.onMessageDisplayed.bind(e)),
            e
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            this.core
              .on('core.field.valid', this.fieldValidHandler)
              .on('core.field.invalid', this.fieldInvalidHandler)
              .on('core.element.validated', this.elementValidatedHandler)
              .on('plugins.message.displayed', this.messageDisplayedHandler);
          }),
          (n.prototype.uninstall = function () {
            this.core
              .off('core.field.valid', this.fieldValidHandler)
              .off('core.field.invalid', this.fieldInvalidHandler)
              .off('core.element.validated', this.elementValidatedHandler)
              .off('plugins.message.displayed', this.messageDisplayedHandler);
          }),
          (n.prototype.onElementValidated = function (e) {
            e.valid &&
              (e.element.setAttribute('aria-invalid', 'false'),
              e.element.removeAttribute('aria-describedby'));
          }),
          (n.prototype.onFieldValid = function (e) {
            var t = this.core.getElements(e);
            t &&
              t.forEach(function (e) {
                (e.setAttribute('aria-invalid', 'false'),
                  e.removeAttribute('aria-describedby'));
              });
          }),
          (n.prototype.onFieldInvalid = function (e) {
            var t = this.core.getElements(e);
            t &&
              t.forEach(function (e) {
                return e.setAttribute('aria-invalid', 'true');
              });
          }),
          (n.prototype.onMessageDisplayed = function (e) {
            (e.messageElement.setAttribute('role', 'alert'),
              e.messageElement.setAttribute('aria-hidden', 'false'));
            var t = this.core.getElements(e.field),
              n = t.indexOf(e.element),
              i = 'js-fv-'
                .concat(e.field, '-')
                .concat(n, '-')
                .concat(Date.now(), '-message');
            (e.messageElement.setAttribute('id', i),
              e.element.setAttribute('aria-describedby', i));
            var r = e.element.getAttribute('type');
            ('radio' !== r && 'checkbox' !== r) ||
              t.forEach(function (e) {
                return e.setAttribute('aria-describedby', i);
              });
          }),
          n
        );
      })(o.Plugin);
    return ((u.Aria = t), u);
  })();
  var f,
    p = c.exports,
    h = { exports: {} },
    m = {};
  h.exports = (function () {
    if (f) return m;
    f = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          return (
            (n.addedFields = new Map()),
            (n.opts = Object.assign(
              {},
              { html5Input: !1, pluginPrefix: 'data-fvp-', prefix: 'data-fv-' },
              e,
            )),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            (n.fieldRemovedHandler = n.onFieldRemoved.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            var e = this;
            this.parsePlugins();
            var t = this.parseOptions();
            (Object.keys(t).forEach(function (n) {
              (e.addedFields.has(n) || e.addedFields.set(n, !0),
                e.core.addField(n, t[n]));
            }),
              this.core
                .on('core.field.added', this.fieldAddedHandler)
                .on('core.field.removed', this.fieldRemovedHandler));
          }),
          (n.prototype.uninstall = function () {
            (this.addedFields.clear(),
              this.core
                .off('core.field.added', this.fieldAddedHandler)
                .off('core.field.removed', this.fieldRemovedHandler));
          }),
          (n.prototype.onFieldAdded = function (e) {
            var t = this,
              n = e.elements;
            n &&
              0 !== n.length &&
              !this.addedFields.has(e.field) &&
              (this.addedFields.set(e.field, !0),
              n.forEach(function (n) {
                var i = t.parseElement(n);
                if (!t.isEmptyOption(i)) {
                  var r = {
                    selector: e.options.selector,
                    validators: Object.assign(
                      {},
                      e.options.validators || {},
                      i.validators,
                    ),
                  };
                  t.core.setFieldOptions(e.field, r);
                }
              }));
          }),
          (n.prototype.onFieldRemoved = function (e) {
            e.field &&
              this.addedFields.has(e.field) &&
              this.addedFields.delete(e.field);
          }),
          (n.prototype.parseOptions = function () {
            var e = this,
              t = this.opts.prefix,
              n = {},
              i = this.core.getFields(),
              r = this.core.getFormElement();
            return (
              [].slice
                .call(r.querySelectorAll('[name], ['.concat(t, 'field]')))
                .forEach(function (i) {
                  var r = e.parseElement(i);
                  if (!e.isEmptyOption(r)) {
                    var o =
                      i.getAttribute('name') ||
                      i.getAttribute(''.concat(t, 'field'));
                    n[o] = Object.assign({}, n[o], r);
                  }
                }),
              Object.keys(n).forEach(function (e) {
                Object.keys(n[e].validators).forEach(function (t) {
                  ((n[e].validators[t].enabled =
                    n[e].validators[t].enabled || !1),
                    i[e] &&
                      i[e].validators &&
                      i[e].validators[t] &&
                      Object.assign(n[e].validators[t], i[e].validators[t]));
                });
              }),
              Object.assign({}, i, n)
            );
          }),
          (n.prototype.createPluginInstance = function (e, t) {
            for (
              var n = e.split('.'), i = window || this, r = 0, o = n.length;
              r < o;
              r++
            )
              i = i[n[r]];
            if ('function' != typeof i)
              throw new Error('the plugin '.concat(e, " doesn't exist"));
            return new i(t);
          }),
          (n.prototype.parsePlugins = function () {
            for (
              var e,
                t = this,
                n = this.core.getFormElement(),
                i = new RegExp(
                  '^'.concat(
                    this.opts.pluginPrefix,
                    '([a-z0-9-]+)(___)*([a-z0-9-]+)*$',
                  ),
                ),
                r = n.attributes.length,
                o = {},
                a = 0;
              a < r;
              a++
            ) {
              var s = n.attributes[a].name,
                l = n.attributes[a].value,
                d = i.exec(s);
              if (d && 4 === d.length) {
                var c = this.toCamelCase(d[1]);
                o[c] = Object.assign(
                  {},
                  d[3]
                    ? (((e = {})[this.toCamelCase(d[3])] = l), e)
                    : { enabled: '' === l || 'true' === l },
                  o[c],
                );
              }
            }
            Object.keys(o).forEach(function (e) {
              var n = o[e],
                i = n.enabled,
                r = n.class;
              if (i && r) {
                (delete n.enabled, delete n.clazz);
                var a = t.createPluginInstance(r, n);
                t.core.registerPlugin(e, a);
              }
            });
          }),
          (n.prototype.isEmptyOption = function (e) {
            var t = e.validators;
            return 0 === Object.keys(t).length && t.constructor === Object;
          }),
          (n.prototype.parseElement = function (e) {
            for (
              var t = new RegExp(
                  '^'.concat(
                    this.opts.prefix,
                    '([a-z0-9-]+)(___)*([a-z0-9-]+)*$',
                  ),
                ),
                n = e.attributes.length,
                i = {},
                r = e.getAttribute('type'),
                o = 0;
              o < n;
              o++
            ) {
              var a = e.attributes[o].name,
                s = e.attributes[o].value;
              if (this.opts.html5Input)
                switch (!0) {
                  case 'minlength' === a:
                    i.stringLength = Object.assign(
                      {},
                      { enabled: !0, min: parseInt(s, 10) },
                      i.stringLength,
                    );
                    break;
                  case 'maxlength' === a:
                    i.stringLength = Object.assign(
                      {},
                      { enabled: !0, max: parseInt(s, 10) },
                      i.stringLength,
                    );
                    break;
                  case 'pattern' === a:
                    i.regexp = Object.assign(
                      {},
                      { enabled: !0, regexp: s },
                      i.regexp,
                    );
                    break;
                  case 'required' === a:
                    i.notEmpty = Object.assign({}, { enabled: !0 }, i.notEmpty);
                    break;
                  case 'type' === a && 'color' === s:
                    i.color = Object.assign(
                      {},
                      { enabled: !0, type: 'hex' },
                      i.color,
                    );
                    break;
                  case 'type' === a && 'email' === s:
                    i.emailAddress = Object.assign(
                      {},
                      { enabled: !0 },
                      i.emailAddress,
                    );
                    break;
                  case 'type' === a && 'url' === s:
                    i.uri = Object.assign({}, { enabled: !0 }, i.uri);
                    break;
                  case 'type' === a && 'range' === s:
                    i.between = Object.assign(
                      {},
                      {
                        enabled: !0,
                        max: parseFloat(e.getAttribute('max')),
                        min: parseFloat(e.getAttribute('min')),
                      },
                      i.between,
                    );
                    break;
                  case 'min' === a && 'date' !== r && 'range' !== r:
                    i.greaterThan = Object.assign(
                      {},
                      { enabled: !0, min: parseFloat(s) },
                      i.greaterThan,
                    );
                    break;
                  case 'max' === a && 'date' !== r && 'range' !== r:
                    i.lessThan = Object.assign(
                      {},
                      { enabled: !0, max: parseFloat(s) },
                      i.lessThan,
                    );
                }
              var l = t.exec(a);
              if (l && 4 === l.length) {
                var d = this.toCamelCase(l[1]);
                (i[d] || (i[d] = {}),
                  l[3]
                    ? (i[d][this.toCamelCase(l[3])] = this.normalizeValue(s))
                    : (!0 === i[d].enabled && !1 === i[d].enabled) ||
                      (i[d].enabled = '' === s || 'true' === s));
              }
            }
            return { validators: i };
          }),
          (n.prototype.normalizeValue = function (e) {
            return 'true' === e || '' === e || ('false' !== e && e);
          }),
          (n.prototype.toUpperCase = function (e) {
            return e.charAt(1).toUpperCase();
          }),
          (n.prototype.toCamelCase = function (e) {
            return e.replace(/-./g, this.toUpperCase);
          }),
          n
        );
      })(o.Plugin);
    return ((m.Declarative = t), m);
  })();
  var v,
    g = h.exports,
    y = { exports: {} },
    b = {};
  y.exports = (function () {
    if (v) return b;
    v = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n() {
          var e = t.call(this, {}) || this;
          return ((e.onValidHandler = e.onFormValid.bind(e)), e);
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            if (
              this.core
                .getFormElement()
                .querySelectorAll('[type="submit"][name="submit"]').length
            )
              throw new Error(
                'Do not use `submit` for the name attribute of submit button',
              );
            this.core.on('core.form.valid', this.onValidHandler);
          }),
          (n.prototype.uninstall = function () {
            this.core.off('core.form.valid', this.onValidHandler);
          }),
          (n.prototype.onFormValid = function () {
            var e = this.core.getFormElement();
            this.isEnabled && e instanceof HTMLFormElement && e.submit();
          }),
          n
        );
      })(o.Plugin);
    return ((b.DefaultSubmit = t), b);
  })();
  var E,
    x = y.exports,
    V = { exports: {} },
    A = {};
  V.exports = (function () {
    if (E) return A;
    E = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          return (
            (n.opts = e || {}),
            (n.triggerExecutedHandler = n.onTriggerExecuted.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            this.core.on(
              'plugins.trigger.executed',
              this.triggerExecutedHandler,
            );
          }),
          (n.prototype.uninstall = function () {
            this.core.off(
              'plugins.trigger.executed',
              this.triggerExecutedHandler,
            );
          }),
          (n.prototype.onTriggerExecuted = function (e) {
            if (this.isEnabled && this.opts[e.field])
              for (
                var t = 0, n = this.opts[e.field].split(' ');
                t < n.length;
                t++
              ) {
                var i = n[t].trim();
                this.opts[i] && this.core.revalidateField(i);
              }
          }),
          n
        );
      })(o.Plugin);
    return ((A.Dependency = t), A);
  })();
  var w,
    F = V.exports,
    O = { exports: {} },
    C = {};
  O.exports = (function () {
    if (w) return C;
    w = 1;
    var e = o,
      t = function (e, n) {
        return (
          (t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          t(e, n)
        );
      },
      n = e.utils.removeUndefined,
      i = (function (e) {
        function i(t) {
          var r = e.call(this, t) || this;
          return (
            (r.opts = Object.assign({}, { excluded: i.defaultIgnore }, n(t))),
            (r.ignoreValidationFilter = r.ignoreValidation.bind(r)),
            r
          );
        }
        return (
          (function (e, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(i, e),
          (i.defaultIgnore = function (e, t, n) {
            var i = !!(
                t.offsetWidth ||
                t.offsetHeight ||
                t.getClientRects().length
              ),
              r = t.getAttribute('disabled');
            return (
              '' === r ||
              'disabled' === r ||
              'hidden' === t.getAttribute('type') ||
              !i
            );
          }),
          (i.prototype.install = function () {
            this.core.registerFilter(
              'element-ignored',
              this.ignoreValidationFilter,
            );
          }),
          (i.prototype.uninstall = function () {
            this.core.deregisterFilter(
              'element-ignored',
              this.ignoreValidationFilter,
            );
          }),
          (i.prototype.ignoreValidation = function (e, t, n) {
            return (
              !!this.isEnabled && this.opts.excluded.apply(this, [e, t, n])
            );
          }),
          i
        );
      })(e.Plugin);
    return ((C.Excluded = i), C);
  })();
  var I,
    _ = O.exports,
    H = { exports: {} },
    S = {};
  H.exports = (function () {
    if (I) return S;
    I = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          return (
            (n.statuses = new Map()),
            (n.opts = Object.assign(
              {},
              { onStatusChanged: function () {} },
              e,
            )),
            (n.elementValidatingHandler = n.onElementValidating.bind(n)),
            (n.elementValidatedHandler = n.onElementValidated.bind(n)),
            (n.elementNotValidatedHandler = n.onElementNotValidated.bind(n)),
            (n.elementIgnoredHandler = n.onElementIgnored.bind(n)),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            (n.fieldRemovedHandler = n.onFieldRemoved.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            this.core
              .on('core.element.validating', this.elementValidatingHandler)
              .on('core.element.validated', this.elementValidatedHandler)
              .on('core.element.notvalidated', this.elementNotValidatedHandler)
              .on('core.element.ignored', this.elementIgnoredHandler)
              .on('core.field.added', this.fieldAddedHandler)
              .on('core.field.removed', this.fieldRemovedHandler);
          }),
          (n.prototype.uninstall = function () {
            (this.statuses.clear(),
              this.core
                .off('core.element.validating', this.elementValidatingHandler)
                .off('core.element.validated', this.elementValidatedHandler)
                .off(
                  'core.element.notvalidated',
                  this.elementNotValidatedHandler,
                )
                .off('core.element.ignored', this.elementIgnoredHandler)
                .off('core.field.added', this.fieldAddedHandler)
                .off('core.field.removed', this.fieldRemovedHandler));
          }),
          (n.prototype.areFieldsValid = function () {
            return Array.from(this.statuses.values()).every(function (e) {
              return 'Valid' === e || 'NotValidated' === e || 'Ignored' === e;
            });
          }),
          (n.prototype.getStatuses = function () {
            return this.isEnabled ? this.statuses : new Map();
          }),
          (n.prototype.onFieldAdded = function (e) {
            this.statuses.set(e.field, 'NotValidated');
          }),
          (n.prototype.onFieldRemoved = function (e) {
            (this.statuses.has(e.field) && this.statuses.delete(e.field),
              this.handleStatusChanged(this.areFieldsValid()));
          }),
          (n.prototype.onElementValidating = function (e) {
            (this.statuses.set(e.field, 'Validating'),
              this.handleStatusChanged(!1));
          }),
          (n.prototype.onElementValidated = function (e) {
            (this.statuses.set(e.field, e.valid ? 'Valid' : 'Invalid'),
              e.valid
                ? this.handleStatusChanged(this.areFieldsValid())
                : this.handleStatusChanged(!1));
          }),
          (n.prototype.onElementNotValidated = function (e) {
            (this.statuses.set(e.field, 'NotValidated'),
              this.handleStatusChanged(!1));
          }),
          (n.prototype.onElementIgnored = function (e) {
            (this.statuses.set(e.field, 'Ignored'),
              this.handleStatusChanged(this.areFieldsValid()));
          }),
          (n.prototype.handleStatusChanged = function (e) {
            this.isEnabled && this.opts.onStatusChanged(e);
          }),
          n
        );
      })(o.Plugin);
    return ((S.FieldStatus = t), S);
  })();
  var k,
    P = H.exports,
    j = { exports: {} },
    N = {},
    L = { exports: {} },
    T = {};
  L.exports = (function () {
    if (k) return T;
    k = 1;
    var e = o,
      t = function (e, n) {
        return (
          (t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          t(e, n)
        );
      },
      n = e.utils.classSet,
      i = (function (e) {
        function i(t) {
          var n = e.call(this, t) || this;
          return (
            (n.useDefaultContainer = !1),
            (n.messages = new Map()),
            (n.defaultContainer = document.createElement('div')),
            (n.useDefaultContainer = !t || !t.container),
            (n.opts = Object.assign(
              {},
              {
                container: function (e, t) {
                  return n.defaultContainer;
                },
              },
              t,
            )),
            (n.elementIgnoredHandler = n.onElementIgnored.bind(n)),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            (n.fieldRemovedHandler = n.onFieldRemoved.bind(n)),
            (n.validatorValidatedHandler = n.onValidatorValidated.bind(n)),
            (n.validatorNotValidatedHandler =
              n.onValidatorNotValidated.bind(n)),
            n
          );
        }
        return (
          (function (e, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(i, e),
          (i.getClosestContainer = function (e, t, n) {
            for (
              var i = e;
              i && i !== t && ((i = i.parentElement), !n.test(i.className));

            );
            return i;
          }),
          (i.prototype.install = function () {
            (this.useDefaultContainer &&
              this.core.getFormElement().appendChild(this.defaultContainer),
              this.core
                .on('core.element.ignored', this.elementIgnoredHandler)
                .on('core.field.added', this.fieldAddedHandler)
                .on('core.field.removed', this.fieldRemovedHandler)
                .on('core.validator.validated', this.validatorValidatedHandler)
                .on(
                  'core.validator.notvalidated',
                  this.validatorNotValidatedHandler,
                ));
          }),
          (i.prototype.uninstall = function () {
            (this.useDefaultContainer &&
              this.core.getFormElement().removeChild(this.defaultContainer),
              this.messages.forEach(function (e) {
                return e.parentNode.removeChild(e);
              }),
              this.messages.clear(),
              this.core
                .off('core.element.ignored', this.elementIgnoredHandler)
                .off('core.field.added', this.fieldAddedHandler)
                .off('core.field.removed', this.fieldRemovedHandler)
                .off('core.validator.validated', this.validatorValidatedHandler)
                .off(
                  'core.validator.notvalidated',
                  this.validatorNotValidatedHandler,
                ));
          }),
          (i.prototype.onEnabled = function () {
            this.messages.forEach(function (e, t, i) {
              n(t, {
                'fv-plugins-message-container--enabled': !0,
                'fv-plugins-message-container--disabled': !1,
              });
            });
          }),
          (i.prototype.onDisabled = function () {
            this.messages.forEach(function (e, t, i) {
              n(t, {
                'fv-plugins-message-container--enabled': !1,
                'fv-plugins-message-container--disabled': !0,
              });
            });
          }),
          (i.prototype.onFieldAdded = function (e) {
            var t = this,
              n = e.elements;
            n &&
              (n.forEach(function (e) {
                var n = t.messages.get(e);
                n && (n.parentNode.removeChild(n), t.messages.delete(e));
              }),
              this.prepareFieldContainer(e.field, n));
          }),
          (i.prototype.onFieldRemoved = function (e) {
            var t = this;
            if (e.elements.length && e.field) {
              var n = e.elements[0].getAttribute('type');
              ('radio' === n || 'checkbox' === n
                ? [e.elements[0]]
                : e.elements
              ).forEach(function (e) {
                if (t.messages.has(e)) {
                  var n = t.messages.get(e);
                  (n.parentNode.removeChild(n), t.messages.delete(e));
                }
              });
            }
          }),
          (i.prototype.prepareFieldContainer = function (e, t) {
            var n = this;
            if (t.length) {
              var i = t[0].getAttribute('type');
              'radio' === i || 'checkbox' === i
                ? this.prepareElementContainer(e, t[0], t)
                : t.forEach(function (i) {
                    return n.prepareElementContainer(e, i, t);
                  });
            }
          }),
          (i.prototype.prepareElementContainer = function (e, t, i) {
            var r;
            if ('string' == typeof this.opts.container) {
              var o =
                '#' === this.opts.container.charAt(0)
                  ? '[id="'.concat(this.opts.container.substring(1), '"]')
                  : this.opts.container;
              r = this.core.getFormElement().querySelector(o);
            } else r = this.opts.container(e, t);
            var a = document.createElement('div');
            (r.appendChild(a),
              n(a, {
                'fv-plugins-message-container': !0,
                'fv-plugins-message-container--enabled': this.isEnabled,
                'fv-plugins-message-container--disabled': !this.isEnabled,
              }),
              this.core.emit('plugins.message.placed', {
                element: t,
                elements: i,
                field: e,
                messageElement: a,
              }),
              this.messages.set(t, a));
          }),
          (i.prototype.getMessage = function (e) {
            return 'string' == typeof e.message
              ? e.message
              : e.message[this.core.getLocale()];
          }),
          (i.prototype.onValidatorValidated = function (e) {
            var t,
              i = e.elements,
              r = e.element.getAttribute('type'),
              o =
                ('radio' === r || 'checkbox' === r) && i.length > 0
                  ? i[0]
                  : e.element;
            if (this.messages.has(o)) {
              var a = this.messages.get(o),
                s = a.querySelector(
                  '[data-field="'
                    .concat(e.field.replace(/"/g, '\\"'), '"][data-validator="')
                    .concat(e.validator.replace(/"/g, '\\"'), '"]'),
                );
              if (s || e.result.valid)
                s && !e.result.valid
                  ? ((s.innerHTML = this.getMessage(e.result)),
                    this.core.emit('plugins.message.displayed', {
                      element: e.element,
                      field: e.field,
                      message: e.result.message,
                      messageElement: s,
                      meta: e.result.meta,
                      validator: e.validator,
                    }))
                  : s && e.result.valid && a.removeChild(s);
              else {
                var l = document.createElement('div');
                ((l.innerHTML = this.getMessage(e.result)),
                  l.setAttribute('data-field', e.field),
                  l.setAttribute('data-validator', e.validator),
                  this.opts.clazz &&
                    n(l, (((t = {})[this.opts.clazz] = !0), t)),
                  a.appendChild(l),
                  this.core.emit('plugins.message.displayed', {
                    element: e.element,
                    field: e.field,
                    message: e.result.message,
                    messageElement: l,
                    meta: e.result.meta,
                    validator: e.validator,
                  }));
              }
            }
          }),
          (i.prototype.onValidatorNotValidated = function (e) {
            var t = e.elements,
              n = e.element.getAttribute('type'),
              i = 'radio' === n || 'checkbox' === n ? t[0] : e.element;
            if (this.messages.has(i)) {
              var r = this.messages.get(i),
                o = r.querySelector(
                  '[data-field="'
                    .concat(e.field.replace(/"/g, '\\"'), '"][data-validator="')
                    .concat(e.validator.replace(/"/g, '\\"'), '"]'),
                );
              o && r.removeChild(o);
            }
          }),
          (i.prototype.onElementIgnored = function (e) {
            var t = e.elements,
              n = e.element.getAttribute('type'),
              i = 'radio' === n || 'checkbox' === n ? t[0] : e.element;
            if (this.messages.has(i)) {
              var r = this.messages.get(i);
              [].slice
                .call(
                  r.querySelectorAll(
                    '[data-field="'.concat(e.field.replace(/"/g, '\\"'), '"]'),
                  ),
                )
                .forEach(function (e) {
                  r.removeChild(e);
                });
            }
          }),
          i
        );
      })(e.Plugin);
    return ((T.Message = i), T);
  })();
  var M,
    D = L.exports;
  /**
   * FormValidation (https://formvalidation.io)
   * The best validation library for JavaScript
   * (c) 2013 - 2023 Nguyen Huu Phuoc <me@phuoc.ng>
   *
   * @license https://formvalidation.io/license
   * @package @form-validation/plugin-framework
   * @version 2.4.0
   */ j.exports = (function () {
    if (M) return N;
    M = 1;
    var e = o,
      t = D,
      n = function (e, t) {
        return (
          (n =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          n(e, t)
        );
      },
      i = e.utils.classSet,
      r = e.utils.closest,
      a = (function (e) {
        function o(t) {
          var n = e.call(this, t) || this;
          return (
            (n.results = new Map()),
            (n.containers = new Map()),
            (n.opts = Object.assign(
              {},
              {
                defaultMessageContainer: !0,
                eleInvalidClass: '',
                eleValidClass: '',
                rowClasses: '',
                rowValidatingClass: '',
              },
              t,
            )),
            (n.elementIgnoredHandler = n.onElementIgnored.bind(n)),
            (n.elementValidatingHandler = n.onElementValidating.bind(n)),
            (n.elementValidatedHandler = n.onElementValidated.bind(n)),
            (n.elementNotValidatedHandler = n.onElementNotValidated.bind(n)),
            (n.iconPlacedHandler = n.onIconPlaced.bind(n)),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            (n.fieldRemovedHandler = n.onFieldRemoved.bind(n)),
            (n.messagePlacedHandler = n.onMessagePlaced.bind(n)),
            n
          );
        }
        return (
          (function (e, t) {
            if ('function' != typeof t && null !== t)
              throw new TypeError(
                'Class extends value ' +
                  String(t) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (n(e, t),
              (e.prototype =
                null === t
                  ? Object.create(t)
                  : ((i.prototype = t.prototype), new i())));
          })(o, e),
          (o.prototype.install = function () {
            var e,
              n = this;
            (i(
              this.core.getFormElement(),
              (((e = {})[this.opts.formClass] = !0),
              (e['fv-plugins-framework'] = !0),
              e),
            ),
              this.core
                .on('core.element.ignored', this.elementIgnoredHandler)
                .on('core.element.validating', this.elementValidatingHandler)
                .on('core.element.validated', this.elementValidatedHandler)
                .on(
                  'core.element.notvalidated',
                  this.elementNotValidatedHandler,
                )
                .on('plugins.icon.placed', this.iconPlacedHandler)
                .on('core.field.added', this.fieldAddedHandler)
                .on('core.field.removed', this.fieldRemovedHandler),
              this.opts.defaultMessageContainer &&
                (this.core.registerPlugin(
                  o.MESSAGE_PLUGIN,
                  new t.Message({
                    clazz: this.opts.messageClass,
                    container: function (e, i) {
                      var o =
                          'string' == typeof n.opts.rowSelector
                            ? n.opts.rowSelector
                            : n.opts.rowSelector(e, i),
                        a = r(i, o);
                      return t.Message.getClosestContainer(
                        i,
                        a,
                        n.opts.rowPattern,
                      );
                    },
                  }),
                ),
                this.core.on(
                  'plugins.message.placed',
                  this.messagePlacedHandler,
                )));
          }),
          (o.prototype.uninstall = function () {
            var e;
            (this.results.clear(),
              this.containers.clear(),
              i(
                this.core.getFormElement(),
                (((e = {})[this.opts.formClass] = !1),
                (e['fv-plugins-framework'] = !1),
                e),
              ),
              this.core
                .off('core.element.ignored', this.elementIgnoredHandler)
                .off('core.element.validating', this.elementValidatingHandler)
                .off('core.element.validated', this.elementValidatedHandler)
                .off(
                  'core.element.notvalidated',
                  this.elementNotValidatedHandler,
                )
                .off('plugins.icon.placed', this.iconPlacedHandler)
                .off('core.field.added', this.fieldAddedHandler)
                .off('core.field.removed', this.fieldRemovedHandler),
              this.opts.defaultMessageContainer &&
                (this.core.deregisterPlugin(o.MESSAGE_PLUGIN),
                this.core.off(
                  'plugins.message.placed',
                  this.messagePlacedHandler,
                )));
          }),
          (o.prototype.onEnabled = function () {
            var e;
            (i(
              this.core.getFormElement(),
              (((e = {})[this.opts.formClass] = !0), e),
            ),
              this.opts.defaultMessageContainer &&
                this.core.enablePlugin(o.MESSAGE_PLUGIN));
          }),
          (o.prototype.onDisabled = function () {
            var e;
            (i(
              this.core.getFormElement(),
              (((e = {})[this.opts.formClass] = !1), e),
            ),
              this.opts.defaultMessageContainer &&
                this.core.disablePlugin(o.MESSAGE_PLUGIN));
          }),
          (o.prototype.onIconPlaced = function (e) {}),
          (o.prototype.onMessagePlaced = function (e) {}),
          (o.prototype.onFieldAdded = function (e) {
            var t = this,
              n = e.elements;
            n &&
              (n.forEach(function (e) {
                var n,
                  r = t.containers.get(e);
                r &&
                  (i(
                    r,
                    (((n = {})[t.opts.rowInvalidClass] = !1),
                    (n[t.opts.rowValidatingClass] = !1),
                    (n[t.opts.rowValidClass] = !1),
                    (n['fv-plugins-icon-container'] = !1),
                    n),
                  ),
                  t.containers.delete(e));
              }),
              this.prepareFieldContainer(e.field, n));
          }),
          (o.prototype.onFieldRemoved = function (e) {
            var t = this;
            e.elements.forEach(function (e) {
              var n,
                r = t.containers.get(e);
              r &&
                i(
                  r,
                  (((n = {})[t.opts.rowInvalidClass] = !1),
                  (n[t.opts.rowValidatingClass] = !1),
                  (n[t.opts.rowValidClass] = !1),
                  n),
                );
            });
          }),
          (o.prototype.prepareFieldContainer = function (e, t) {
            var n = this;
            if (t.length) {
              var i = t[0].getAttribute('type');
              'radio' === i || 'checkbox' === i
                ? this.prepareElementContainer(e, t[0])
                : t.forEach(function (t) {
                    return n.prepareElementContainer(e, t);
                  });
            }
          }),
          (o.prototype.prepareElementContainer = function (e, t) {
            var n,
              o =
                'string' == typeof this.opts.rowSelector
                  ? this.opts.rowSelector
                  : this.opts.rowSelector(e, t),
              a = r(t, o);
            a !== t &&
              (i(
                a,
                (((n = {})[this.opts.rowClasses] = !0),
                (n['fv-plugins-icon-container'] = !0),
                n),
              ),
              this.containers.set(t, a));
          }),
          (o.prototype.onElementValidating = function (e) {
            this.removeClasses(e.element, e.elements);
          }),
          (o.prototype.onElementNotValidated = function (e) {
            this.removeClasses(e.element, e.elements);
          }),
          (o.prototype.onElementIgnored = function (e) {
            this.removeClasses(e.element, e.elements);
          }),
          (o.prototype.removeClasses = function (e, t) {
            var n,
              r = this,
              o = e.getAttribute('type'),
              a = 'radio' === o || 'checkbox' === o ? t[0] : e;
            t.forEach(function (e) {
              var t;
              i(
                e,
                (((t = {})[r.opts.eleValidClass] = !1),
                (t[r.opts.eleInvalidClass] = !1),
                t),
              );
            });
            var s = this.containers.get(a);
            s &&
              i(
                s,
                (((n = {})[this.opts.rowInvalidClass] = !1),
                (n[this.opts.rowValidatingClass] = !1),
                (n[this.opts.rowValidClass] = !1),
                n),
              );
          }),
          (o.prototype.onElementValidated = function (e) {
            var t,
              n,
              r = this,
              o = e.elements,
              a = e.element.getAttribute('type'),
              s = 'radio' === a || 'checkbox' === a ? o[0] : e.element;
            o.forEach(function (t) {
              var n;
              i(
                t,
                (((n = {})[r.opts.eleValidClass] = e.valid),
                (n[r.opts.eleInvalidClass] = !e.valid),
                n),
              );
            });
            var l = this.containers.get(s);
            if (l)
              if (e.valid) {
                this.results.delete(s);
                var d = !0;
                (this.containers.forEach(function (e, t) {
                  e === l && !1 === r.results.get(t) && (d = !1);
                }),
                  d &&
                    i(
                      l,
                      (((n = {})[this.opts.rowInvalidClass] = !1),
                      (n[this.opts.rowValidatingClass] = !1),
                      (n[this.opts.rowValidClass] = !0),
                      n),
                    ));
              } else
                (this.results.set(s, !1),
                  i(
                    l,
                    (((t = {})[this.opts.rowInvalidClass] = !0),
                    (t[this.opts.rowValidatingClass] = !1),
                    (t[this.opts.rowValidClass] = !1),
                    t),
                  ));
          }),
          (o.MESSAGE_PLUGIN = '___frameworkMessage'),
          o
        );
      })(e.Plugin);
    return ((N.Framework = a), N);
  })();
  var R,
    z = j.exports,
    U = { exports: {} },
    B = {};
  U.exports = (function () {
    if (R) return B;
    R = 1;
    var e = o,
      t = function (e, n) {
        return (
          (t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          t(e, n)
        );
      },
      n = e.utils.classSet,
      i = (function (e) {
        function i(t) {
          var n = e.call(this, t) || this;
          return (
            (n.icons = new Map()),
            (n.opts = Object.assign(
              {},
              {
                invalid: 'fv-plugins-icon--invalid',
                onPlaced: function () {},
                onSet: function () {},
                valid: 'fv-plugins-icon--valid',
                validating: 'fv-plugins-icon--validating',
              },
              t,
            )),
            (n.elementValidatingHandler = n.onElementValidating.bind(n)),
            (n.elementValidatedHandler = n.onElementValidated.bind(n)),
            (n.elementNotValidatedHandler = n.onElementNotValidated.bind(n)),
            (n.elementIgnoredHandler = n.onElementIgnored.bind(n)),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            n
          );
        }
        return (
          (function (e, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(i, e),
          (i.prototype.install = function () {
            this.core
              .on('core.element.validating', this.elementValidatingHandler)
              .on('core.element.validated', this.elementValidatedHandler)
              .on('core.element.notvalidated', this.elementNotValidatedHandler)
              .on('core.element.ignored', this.elementIgnoredHandler)
              .on('core.field.added', this.fieldAddedHandler);
          }),
          (i.prototype.uninstall = function () {
            (this.icons.forEach(function (e) {
              return e.parentNode.removeChild(e);
            }),
              this.icons.clear(),
              this.core
                .off('core.element.validating', this.elementValidatingHandler)
                .off('core.element.validated', this.elementValidatedHandler)
                .off(
                  'core.element.notvalidated',
                  this.elementNotValidatedHandler,
                )
                .off('core.element.ignored', this.elementIgnoredHandler)
                .off('core.field.added', this.fieldAddedHandler));
          }),
          (i.prototype.onEnabled = function () {
            this.icons.forEach(function (e, t, i) {
              n(t, {
                'fv-plugins-icon--enabled': !0,
                'fv-plugins-icon--disabled': !1,
              });
            });
          }),
          (i.prototype.onDisabled = function () {
            this.icons.forEach(function (e, t, i) {
              n(t, {
                'fv-plugins-icon--enabled': !1,
                'fv-plugins-icon--disabled': !0,
              });
            });
          }),
          (i.prototype.onFieldAdded = function (e) {
            var t = this,
              n = e.elements;
            n &&
              (n.forEach(function (e) {
                var n = t.icons.get(e);
                n && (n.parentNode.removeChild(n), t.icons.delete(e));
              }),
              this.prepareFieldIcon(e.field, n));
          }),
          (i.prototype.prepareFieldIcon = function (e, t) {
            var n = this;
            if (t.length) {
              var i = t[0].getAttribute('type');
              'radio' === i || 'checkbox' === i
                ? this.prepareElementIcon(e, t[0])
                : t.forEach(function (t) {
                    return n.prepareElementIcon(e, t);
                  });
            }
          }),
          (i.prototype.prepareElementIcon = function (e, t) {
            var i = document.createElement('i');
            (i.setAttribute('data-field', e),
              t.parentNode.insertBefore(i, t.nextSibling),
              n(i, {
                'fv-plugins-icon': !0,
                'fv-plugins-icon--enabled': this.isEnabled,
                'fv-plugins-icon--disabled': !this.isEnabled,
              }));
            var r = {
              classes: {
                invalid: this.opts.invalid,
                valid: this.opts.valid,
                validating: this.opts.validating,
              },
              element: t,
              field: e,
              iconElement: i,
            };
            (this.core.emit('plugins.icon.placed', r),
              this.opts.onPlaced(r),
              this.icons.set(t, i));
          }),
          (i.prototype.onElementValidating = function (e) {
            var t,
              n = this.setClasses(
                e.field,
                e.element,
                e.elements,
                (((t = {})[this.opts.invalid] = !1),
                (t[this.opts.valid] = !1),
                (t[this.opts.validating] = !0),
                t),
              ),
              i = {
                element: e.element,
                field: e.field,
                iconElement: n,
                status: 'Validating',
              };
            (this.core.emit('plugins.icon.set', i), this.opts.onSet(i));
          }),
          (i.prototype.onElementValidated = function (e) {
            var t,
              n = this.setClasses(
                e.field,
                e.element,
                e.elements,
                (((t = {})[this.opts.invalid] = !e.valid),
                (t[this.opts.valid] = e.valid),
                (t[this.opts.validating] = !1),
                t),
              ),
              i = {
                element: e.element,
                field: e.field,
                iconElement: n,
                status: e.valid ? 'Valid' : 'Invalid',
              };
            (this.core.emit('plugins.icon.set', i), this.opts.onSet(i));
          }),
          (i.prototype.onElementNotValidated = function (e) {
            var t,
              n = this.setClasses(
                e.field,
                e.element,
                e.elements,
                (((t = {})[this.opts.invalid] = !1),
                (t[this.opts.valid] = !1),
                (t[this.opts.validating] = !1),
                t),
              ),
              i = {
                element: e.element,
                field: e.field,
                iconElement: n,
                status: 'NotValidated',
              };
            (this.core.emit('plugins.icon.set', i), this.opts.onSet(i));
          }),
          (i.prototype.onElementIgnored = function (e) {
            var t,
              n = this.setClasses(
                e.field,
                e.element,
                e.elements,
                (((t = {})[this.opts.invalid] = !1),
                (t[this.opts.valid] = !1),
                (t[this.opts.validating] = !1),
                t),
              ),
              i = {
                element: e.element,
                field: e.field,
                iconElement: n,
                status: 'Ignored',
              };
            (this.core.emit('plugins.icon.set', i), this.opts.onSet(i));
          }),
          (i.prototype.setClasses = function (e, t, i, r) {
            var o = t.getAttribute('type'),
              a = 'radio' === o || 'checkbox' === o ? i[0] : t;
            if (this.icons.has(a)) {
              var s = this.icons.get(a);
              return (n(s, r), s);
            }
            return null;
          }),
          i
        );
      })(e.Plugin);
    return ((B.Icon = i), B);
  })();
  var Y,
    q = U.exports,
    G = { exports: {} },
    Z = {};
  G.exports = (function () {
    if (Y) return Z;
    Y = 1;
    var e = o,
      t = function (e, n) {
        return (
          (t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          t(e, n)
        );
      },
      n = e.utils.removeUndefined,
      i = (function (e) {
        function i(t) {
          var i = e.call(this, t) || this;
          return (
            (i.invalidFields = new Map()),
            (i.opts = Object.assign({}, { enabled: !0 }, n(t))),
            (i.validatorHandler = i.onValidatorValidated.bind(i)),
            (i.shouldValidateFilter = i.shouldValidate.bind(i)),
            (i.fieldAddedHandler = i.onFieldAdded.bind(i)),
            (i.elementNotValidatedHandler = i.onElementNotValidated.bind(i)),
            (i.elementValidatingHandler = i.onElementValidating.bind(i)),
            i
          );
        }
        return (
          (function (e, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(i, e),
          (i.prototype.install = function () {
            this.core
              .on('core.validator.validated', this.validatorHandler)
              .on('core.field.added', this.fieldAddedHandler)
              .on('core.element.notvalidated', this.elementNotValidatedHandler)
              .on('core.element.validating', this.elementValidatingHandler)
              .registerFilter(
                'field-should-validate',
                this.shouldValidateFilter,
              );
          }),
          (i.prototype.uninstall = function () {
            (this.invalidFields.clear(),
              this.core
                .off('core.validator.validated', this.validatorHandler)
                .off('core.field.added', this.fieldAddedHandler)
                .off(
                  'core.element.notvalidated',
                  this.elementNotValidatedHandler,
                )
                .off('core.element.validating', this.elementValidatingHandler)
                .deregisterFilter(
                  'field-should-validate',
                  this.shouldValidateFilter,
                ));
          }),
          (i.prototype.shouldValidate = function (e, t, n, i) {
            return (
              !this.isEnabled ||
              !(
                (!0 === this.opts.enabled || !0 === this.opts.enabled[e]) &&
                this.invalidFields.has(t) &&
                this.invalidFields.get(t).length &&
                -1 === this.invalidFields.get(t).indexOf(i)
              )
            );
          }),
          (i.prototype.onValidatorValidated = function (e) {
            var t = this.invalidFields.has(e.element)
                ? this.invalidFields.get(e.element)
                : [],
              n = t.indexOf(e.validator);
            (e.result.valid && n >= 0
              ? t.splice(n, 1)
              : e.result.valid || -1 !== n || t.push(e.validator),
              this.invalidFields.set(e.element, t));
          }),
          (i.prototype.onFieldAdded = function (e) {
            e.elements && this.clearInvalidFields(e.elements);
          }),
          (i.prototype.onElementNotValidated = function (e) {
            this.clearInvalidFields(e.elements);
          }),
          (i.prototype.onElementValidating = function (e) {
            this.clearInvalidFields(e.elements);
          }),
          (i.prototype.clearInvalidFields = function (e) {
            var t = this;
            e.forEach(function (e) {
              return t.invalidFields.delete(e);
            });
          }),
          i
        );
      })(e.Plugin);
    return ((Z.Sequence = i), Z);
  })();
  var $,
    X = G.exports,
    J = { exports: {} },
    K = {};
  J.exports = (function () {
    if ($) return K;
    $ = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          return (
            (n.isFormValid = !1),
            (n.isButtonClicked = !1),
            (n.opts = Object.assign(
              {},
              {
                aspNetButton: !1,
                buttons: function (e) {
                  return [].slice.call(
                    e.querySelectorAll('[type="submit"]:not([formnovalidate])'),
                  );
                },
                liveMode: !0,
              },
              e,
            )),
            (n.submitHandler = n.handleSubmitEvent.bind(n)),
            (n.buttonClickHandler = n.handleClickEvent.bind(n)),
            (n.ignoreValidationFilter = n.ignoreValidation.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            var e = this;
            if (this.core.getFormElement() instanceof HTMLFormElement) {
              var t = this.core.getFormElement();
              ((this.submitButtons = this.opts.buttons(t)),
                t.setAttribute('novalidate', 'novalidate'),
                t.addEventListener('submit', this.submitHandler),
                (this.hiddenClickedEle = document.createElement('input')),
                this.hiddenClickedEle.setAttribute('type', 'hidden'),
                t.appendChild(this.hiddenClickedEle),
                this.submitButtons.forEach(function (t) {
                  t.addEventListener('click', e.buttonClickHandler);
                }),
                this.core.registerFilter(
                  'element-ignored',
                  this.ignoreValidationFilter,
                ));
            }
          }),
          (n.prototype.uninstall = function () {
            var e = this,
              t = this.core.getFormElement();
            (t instanceof HTMLFormElement &&
              t.removeEventListener('submit', this.submitHandler),
              this.submitButtons.forEach(function (t) {
                t.removeEventListener('click', e.buttonClickHandler);
              }),
              this.hiddenClickedEle.parentElement.removeChild(
                this.hiddenClickedEle,
              ),
              this.core.deregisterFilter(
                'element-ignored',
                this.ignoreValidationFilter,
              ));
          }),
          (n.prototype.handleSubmitEvent = function (e) {
            this.validateForm(e);
          }),
          (n.prototype.handleClickEvent = function (e) {
            var t = e.currentTarget;
            if (((this.isButtonClicked = !0), t instanceof HTMLElement))
              if (this.opts.aspNetButton && !0 === this.isFormValid);
              else {
                (this.core
                  .getFormElement()
                  .removeEventListener('submit', this.submitHandler),
                  (this.clickedButton = e.target));
                var n = this.clickedButton.getAttribute('name'),
                  i = this.clickedButton.getAttribute('value');
                (n &&
                  i &&
                  (this.hiddenClickedEle.setAttribute('name', n),
                  this.hiddenClickedEle.setAttribute('value', i)),
                  this.validateForm(e));
              }
          }),
          (n.prototype.validateForm = function (e) {
            var t = this;
            this.isEnabled &&
              (e.preventDefault(),
              this.core.validate().then(function (e) {
                'Valid' === e &&
                  t.opts.aspNetButton &&
                  !t.isFormValid &&
                  t.clickedButton &&
                  ((t.isFormValid = !0),
                  t.clickedButton.removeEventListener(
                    'click',
                    t.buttonClickHandler,
                  ),
                  t.clickedButton.click());
              }));
          }),
          (n.prototype.ignoreValidation = function (e, t, n) {
            return (
              !!this.isEnabled && !this.opts.liveMode && !this.isButtonClicked
            );
          }),
          n
        );
      })(o.Plugin);
    return ((K.SubmitButton = t), K);
  })();
  var W,
    Q = J.exports,
    ee = { exports: {} },
    te = {};
  ee.exports = (function () {
    if (W) return te;
    W = 1;
    var e = o,
      t = function (e, n) {
        return (
          (t =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          t(e, n)
        );
      },
      n = e.utils.classSet,
      i = (function (e) {
        function i(t) {
          var n = e.call(this, t) || this;
          return (
            (n.messages = new Map()),
            (n.opts = Object.assign(
              {},
              { placement: 'top', trigger: 'click' },
              t,
            )),
            (n.iconPlacedHandler = n.onIconPlaced.bind(n)),
            (n.validatorValidatedHandler = n.onValidatorValidated.bind(n)),
            (n.elementValidatedHandler = n.onElementValidated.bind(n)),
            (n.documentClickHandler = n.onDocumentClicked.bind(n)),
            n
          );
        }
        return (
          (function (e, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = e;
            }
            (t(e, n),
              (e.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(i, e),
          (i.prototype.install = function () {
            var e;
            ((this.tip = document.createElement('div')),
              n(
                this.tip,
                (((e = { 'fv-plugins-tooltip': !0 })[
                  'fv-plugins-tooltip--'.concat(this.opts.placement)
                ] = !0),
                e),
              ),
              document.body.appendChild(this.tip),
              this.core
                .on('plugins.icon.placed', this.iconPlacedHandler)
                .on('core.validator.validated', this.validatorValidatedHandler)
                .on('core.element.validated', this.elementValidatedHandler),
              'click' === this.opts.trigger &&
                document.addEventListener('click', this.documentClickHandler));
          }),
          (i.prototype.uninstall = function () {
            (this.messages.clear(),
              document.body.removeChild(this.tip),
              this.core
                .off('plugins.icon.placed', this.iconPlacedHandler)
                .off('core.validator.validated', this.validatorValidatedHandler)
                .off('core.element.validated', this.elementValidatedHandler),
              'click' === this.opts.trigger &&
                document.removeEventListener(
                  'click',
                  this.documentClickHandler,
                ));
          }),
          (i.prototype.onIconPlaced = function (e) {
            var t = this;
            (n(e.iconElement, { 'fv-plugins-tooltip-icon': !0 }),
              'hover' === this.opts.trigger
                ? (e.iconElement.addEventListener('mouseenter', function (n) {
                    return t.show(e.element, n);
                  }),
                  e.iconElement.addEventListener('mouseleave', function (e) {
                    return t.hide();
                  }))
                : e.iconElement.addEventListener('click', function (n) {
                    return t.show(e.element, n);
                  }));
          }),
          (i.prototype.onValidatorValidated = function (e) {
            if (!e.result.valid) {
              var t = e.elements,
                n = e.element.getAttribute('type'),
                i = 'radio' === n || 'checkbox' === n ? t[0] : e.element,
                r =
                  'string' == typeof e.result.message
                    ? e.result.message
                    : e.result.message[this.core.getLocale()];
              this.messages.set(i, r);
            }
          }),
          (i.prototype.onElementValidated = function (e) {
            if (e.valid) {
              var t = e.elements,
                n = e.element.getAttribute('type'),
                i = 'radio' === n || 'checkbox' === n ? t[0] : e.element;
              this.messages.delete(i);
            }
          }),
          (i.prototype.onDocumentClicked = function (e) {
            this.hide();
          }),
          (i.prototype.show = function (e, t) {
            if (
              this.isEnabled &&
              (t.preventDefault(), t.stopPropagation(), this.messages.has(e))
            ) {
              (n(this.tip, { 'fv-plugins-tooltip--hide': !1 }),
                (this.tip.innerHTML =
                  '<div class="fv-plugins-tooltip__content">'.concat(
                    this.messages.get(e),
                    '</div>',
                  )));
              var i = t.target.getBoundingClientRect(),
                r = this.tip.getBoundingClientRect(),
                o = r.height,
                a = r.width,
                s = 0,
                l = 0;
              switch (this.opts.placement) {
                case 'bottom':
                  ((s = i.top + i.height), (l = i.left + i.width / 2 - a / 2));
                  break;
                case 'bottom-left':
                  ((s = i.top + i.height), (l = i.left));
                  break;
                case 'bottom-right':
                  ((s = i.top + i.height), (l = i.left + i.width - a));
                  break;
                case 'left':
                  ((s = i.top + i.height / 2 - o / 2), (l = i.left - a));
                  break;
                case 'right':
                  ((s = i.top + i.height / 2 - o / 2), (l = i.left + i.width));
                  break;
                case 'top-left':
                  ((s = i.top - o), (l = i.left));
                  break;
                case 'top-right':
                  ((s = i.top - o), (l = i.left + i.width - a));
                  break;
                default:
                  ((s = i.top - o), (l = i.left + i.width / 2 - a / 2));
              }
              ((s +=
                window.scrollY ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                0),
                (l +=
                  window.scrollX ||
                  document.documentElement.scrollLeft ||
                  document.body.scrollLeft ||
                  0),
                this.tip.setAttribute(
                  'style',
                  'top: '.concat(s, 'px; left: ').concat(l, 'px'),
                ));
            }
          }),
          (i.prototype.hide = function () {
            this.isEnabled && n(this.tip, { 'fv-plugins-tooltip--hide': !0 });
          }),
          i
        );
      })(e.Plugin);
    return ((te.Tooltip = i), te);
  })();
  var ne,
    ie = ee.exports,
    re = { exports: {} },
    oe = {};
  re.exports = (function () {
    if (ne) return oe;
    ne = 1;
    var e = function (t, n) {
        return (
          (e =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (e, t) {
                e.__proto__ = t;
              }) ||
            function (e, t) {
              for (var n in t)
                Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }),
          e(t, n)
        );
      },
      t = (function (t) {
        function n(e) {
          var n = t.call(this, e) || this;
          ((n.handlers = []), (n.timers = new Map()));
          var i = document.createElement('div');
          return (
            (n.defaultEvent = 'oninput' in i ? 'input' : 'keyup'),
            (n.opts = Object.assign(
              {},
              { delay: 0, event: n.defaultEvent, threshold: 0 },
              e,
            )),
            (n.fieldAddedHandler = n.onFieldAdded.bind(n)),
            (n.fieldRemovedHandler = n.onFieldRemoved.bind(n)),
            n
          );
        }
        return (
          (function (t, n) {
            if ('function' != typeof n && null !== n)
              throw new TypeError(
                'Class extends value ' +
                  String(n) +
                  ' is not a constructor or null',
              );
            function i() {
              this.constructor = t;
            }
            (e(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((i.prototype = n.prototype), new i())));
          })(n, t),
          (n.prototype.install = function () {
            this.core
              .on('core.field.added', this.fieldAddedHandler)
              .on('core.field.removed', this.fieldRemovedHandler);
          }),
          (n.prototype.uninstall = function () {
            (this.handlers.forEach(function (e) {
              return e.element.removeEventListener(e.event, e.handler);
            }),
              (this.handlers = []),
              this.timers.forEach(function (e) {
                return window.clearTimeout(e);
              }),
              this.timers.clear(),
              this.core
                .off('core.field.added', this.fieldAddedHandler)
                .off('core.field.removed', this.fieldRemovedHandler));
          }),
          (n.prototype.prepareHandler = function (e, t) {
            var n = this;
            t.forEach(function (t) {
              var i = [];
              if (n.opts.event && !1 === n.opts.event[e]) i = [];
              else if (
                n.opts.event &&
                n.opts.event[e] &&
                'function' != typeof n.opts.event[e]
              )
                i = n.opts.event[e].split(' ');
              else if (
                'string' == typeof n.opts.event &&
                n.opts.event !== n.defaultEvent
              )
                i = n.opts.event.split(' ');
              else {
                var r = t.getAttribute('type'),
                  o = t.tagName.toLowerCase();
                i = [
                  'radio' === r ||
                  'checkbox' === r ||
                  'file' === r ||
                  'select' === o
                    ? 'change'
                    : n.ieVersion >= 10 && t.getAttribute('placeholder')
                      ? 'keyup'
                      : n.defaultEvent,
                ];
              }
              i.forEach(function (i) {
                var r = function (i) {
                  return n.handleEvent(i, e, t);
                };
                (n.handlers.push({
                  element: t,
                  event: i,
                  field: e,
                  handler: r,
                }),
                  t.addEventListener(i, r));
              });
            });
          }),
          (n.prototype.handleEvent = function (e, t, n) {
            var i = this;
            if (
              this.isEnabled &&
              this.exceedThreshold(t, n) &&
              this.core.executeFilter('plugins-trigger-should-validate', !0, [
                t,
                n,
              ])
            ) {
              var r = function () {
                  return i.core.validateElement(t, n).then(function (r) {
                    i.core.emit('plugins.trigger.executed', {
                      element: n,
                      event: e,
                      field: t,
                    });
                  });
                },
                o = this.opts.delay[t] || this.opts.delay;
              if (0 === o) r();
              else {
                var a = this.timers.get(n);
                (a && window.clearTimeout(a),
                  this.timers.set(n, window.setTimeout(r, 1e3 * o)));
              }
            }
          }),
          (n.prototype.onFieldAdded = function (e) {
            (this.handlers
              .filter(function (t) {
                return t.field === e.field;
              })
              .forEach(function (e) {
                return e.element.removeEventListener(e.event, e.handler);
              }),
              this.prepareHandler(e.field, e.elements));
          }),
          (n.prototype.onFieldRemoved = function (e) {
            this.handlers
              .filter(function (t) {
                return (
                  t.field === e.field && e.elements.indexOf(t.element) >= 0
                );
              })
              .forEach(function (e) {
                return e.element.removeEventListener(e.event, e.handler);
              });
          }),
          (n.prototype.exceedThreshold = function (e, t) {
            var n =
              0 !== this.opts.threshold[e] &&
              0 !== this.opts.threshold &&
              (this.opts.threshold[e] || this.opts.threshold);
            if (!n) return !0;
            var i = t.getAttribute('type');
            return (
              -1 !==
                [
                  'button',
                  'checkbox',
                  'file',
                  'hidden',
                  'image',
                  'radio',
                  'reset',
                  'submit',
                ].indexOf(i) || this.core.getElementValue(e, t).length >= n
            );
          }),
          n
        );
      })(o.Plugin);
    return ((oe.Trigger = t), oe);
  })();
  var ae,
    se = re.exports,
    le = { exports: {} },
    de = {};
  le.exports = (function () {
    if (ae) return de;
    ae = 1;
    var e = o,
      t = e.utils.format,
      n = e.utils.removeUndefined;
    return (
      (de.between = function () {
        var e = function (e) {
          return parseFloat(''.concat(e).replace(',', '.'));
        };
        return {
          validate: function (i) {
            var r = i.value;
            if ('' === r) return { valid: !0 };
            var o = Object.assign(
                {},
                { inclusive: !0, message: '' },
                n(i.options),
              ),
              a = e(o.min),
              s = e(o.max);
            return o.inclusive
              ? {
                  message: t(
                    i.l10n ? o.message || i.l10n.between.default : o.message,
                    [''.concat(a), ''.concat(s)],
                  ),
                  valid: parseFloat(r) >= a && parseFloat(r) <= s,
                }
              : {
                  message: t(
                    i.l10n
                      ? o.message || i.l10n.between.notInclusive
                      : o.message,
                    [''.concat(a), ''.concat(s)],
                  ),
                  valid: parseFloat(r) > a && parseFloat(r) < s,
                };
          },
        };
      }),
      de
    );
  })();
  var ce,
    ue = le.exports,
    fe = { exports: {} },
    pe = {};
  fe.exports =
    (ce ||
      ((ce = 1),
      (pe.blank = function () {
        return {
          validate: function (e) {
            return { valid: !0 };
          },
        };
      })),
    pe);
  var he,
    me = fe.exports,
    ve = { exports: {} },
    ge = {};
  ve.exports = (function () {
    if (he) return ge;
    he = 1;
    var e = o.utils.call;
    return (
      (ge.callback = function () {
        return {
          validate: function (t) {
            var n = e(t.options.callback, [t]);
            return 'boolean' == typeof n ? { valid: n } : n;
          },
        };
      }),
      ge
    );
  })();
  var ye,
    be = ve.exports,
    Ee = { exports: {} },
    xe = {};
  Ee.exports = (function () {
    if (ye) return xe;
    ye = 1;
    var e = o.utils.format;
    return (
      (xe.choice = function () {
        return {
          validate: function (t) {
            var n =
                'select' === t.element.tagName.toLowerCase()
                  ? t.element.querySelectorAll('option:checked').length
                  : t.elements.filter(function (e) {
                      return e.checked;
                    }).length,
              i = t.options.min ? ''.concat(t.options.min) : '',
              r = t.options.max ? ''.concat(t.options.max) : '',
              o = t.l10n
                ? t.options.message || t.l10n.choice.default
                : t.options.message,
              a = !((i && n < parseInt(i, 10)) || (r && n > parseInt(r, 10)));
            switch (!0) {
              case !!i && !!r:
                o = e(t.l10n ? t.l10n.choice.between : t.options.message, [
                  i,
                  r,
                ]);
                break;
              case !!i:
                o = e(t.l10n ? t.l10n.choice.more : t.options.message, i);
                break;
              case !!r:
                o = e(t.l10n ? t.l10n.choice.less : t.options.message, r);
            }
            return { message: o, valid: a };
          },
        };
      }),
      xe
    );
  })();
  var Ve,
    Ae = Ee.exports,
    we = { exports: {} },
    Fe = {};
  we.exports = (function () {
    if (Ve) return Fe;
    Ve = 1;
    var e = o.algorithms.luhn,
      t = {
        AMERICAN_EXPRESS: { length: [15], prefix: ['34', '37'] },
        DANKORT: { length: [16], prefix: ['5019'] },
        DINERS_CLUB: {
          length: [14],
          prefix: ['300', '301', '302', '303', '304', '305', '36'],
        },
        DINERS_CLUB_US: { length: [16], prefix: ['54', '55'] },
        DISCOVER: {
          length: [16],
          prefix: [
            '6011',
            '622126',
            '622127',
            '622128',
            '622129',
            '62213',
            '62214',
            '62215',
            '62216',
            '62217',
            '62218',
            '62219',
            '6222',
            '6223',
            '6224',
            '6225',
            '6226',
            '6227',
            '6228',
            '62290',
            '62291',
            '622920',
            '622921',
            '622922',
            '622923',
            '622924',
            '622925',
            '644',
            '645',
            '646',
            '647',
            '648',
            '649',
            '65',
          ],
        },
        ELO: {
          length: [16],
          prefix: [
            '4011',
            '4312',
            '4389',
            '4514',
            '4573',
            '4576',
            '5041',
            '5066',
            '5067',
            '509',
            '6277',
            '6362',
            '6363',
            '650',
            '6516',
            '6550',
          ],
        },
        FORBRUGSFORENINGEN: { length: [16], prefix: ['600722'] },
        JCB: {
          length: [16],
          prefix: ['3528', '3529', '353', '354', '355', '356', '357', '358'],
        },
        LASER: {
          length: [16, 17, 18, 19],
          prefix: ['6304', '6706', '6771', '6709'],
        },
        MAESTRO: {
          length: [12, 13, 14, 15, 16, 17, 18, 19],
          prefix: [
            '5018',
            '5020',
            '5038',
            '5868',
            '6304',
            '6759',
            '6761',
            '6762',
            '6763',
            '6764',
            '6765',
            '6766',
          ],
        },
        MASTERCARD: { length: [16], prefix: ['51', '52', '53', '54', '55'] },
        SOLO: { length: [16, 18, 19], prefix: ['6334', '6767'] },
        UNIONPAY: {
          length: [16, 17, 18, 19],
          prefix: [
            '622126',
            '622127',
            '622128',
            '622129',
            '62213',
            '62214',
            '62215',
            '62216',
            '62217',
            '62218',
            '62219',
            '6222',
            '6223',
            '6224',
            '6225',
            '6226',
            '6227',
            '6228',
            '62290',
            '62291',
            '622920',
            '622921',
            '622922',
            '622923',
            '622924',
            '622925',
          ],
        },
        VISA: { length: [16], prefix: ['4'] },
        VISA_ELECTRON: {
          length: [16],
          prefix: ['4026', '417500', '4405', '4508', '4844', '4913', '4917'],
        },
      };
    return (
      (Fe.CREDIT_CARD_TYPES = t),
      (Fe.creditCard = function () {
        return {
          validate: function (n) {
            if ('' === n.value) return { meta: { type: null }, valid: !0 };
            if (/[^0-9-\s]+/.test(n.value))
              return { meta: { type: null }, valid: !1 };
            var i = n.value.replace(/\D/g, '');
            if (!e(i)) return { meta: { type: null }, valid: !1 };
            for (var r = 0, o = Object.keys(t); r < o.length; r++) {
              var a = o[r];
              for (var s in t[a].prefix)
                if (
                  n.value.substr(0, t[a].prefix[s].length) === t[a].prefix[s] &&
                  -1 !== t[a].length.indexOf(i.length)
                )
                  return { meta: { type: a }, valid: !0 };
            }
            return { meta: { type: null }, valid: !1 };
          },
        };
      }),
      Fe
    );
  })();
  var Oe,
    Ce = we.exports,
    Ie = { exports: {} },
    _e = {};
  Ie.exports = (function () {
    if (Oe) return _e;
    Oe = 1;
    var e = o,
      t = e.utils.format,
      n = e.utils.isValidDate,
      i = e.utils.removeUndefined,
      r = function (e, t, n) {
        var i = t.indexOf('YYYY'),
          r = t.indexOf('MM'),
          o = t.indexOf('DD');
        if (-1 === i || -1 === r || -1 === o) return null;
        var a = e.split(' '),
          s = a[0].split(n);
        if (s.length < 3) return null;
        var l = new Date(
            parseInt(s[i], 10),
            parseInt(s[r], 10) - 1,
            parseInt(s[o], 10),
          ),
          d = a.length > 2 ? a[2] : null;
        if (a.length > 1) {
          var c = a[1].split(':'),
            u = c.length > 0 ? parseInt(c[0], 10) : 0;
          (l.setHours(d && 'PM' === d.toUpperCase() && u < 12 ? u + 12 : u),
            l.setMinutes(c.length > 1 ? parseInt(c[1], 10) : 0),
            l.setSeconds(c.length > 2 ? parseInt(c[2], 10) : 0));
        }
        return l;
      },
      a = function (e, t) {
        var n = t
            .replace(/Y/g, 'y')
            .replace(/M/g, 'm')
            .replace(/D/g, 'd')
            .replace(/:m/g, ':M')
            .replace(/:mm/g, ':MM')
            .replace(/:S/, ':s')
            .replace(/:SS/, ':ss'),
          i = e.getDate(),
          r = i < 10 ? '0'.concat(i) : i,
          o = e.getMonth() + 1,
          a = o < 10 ? '0'.concat(o) : o,
          s = ''.concat(e.getFullYear()).substr(2),
          l = e.getFullYear(),
          d = e.getHours() % 12 || 12,
          c = d < 10 ? '0'.concat(d) : d,
          u = e.getHours(),
          f = u < 10 ? '0'.concat(u) : u,
          p = e.getMinutes(),
          h = p < 10 ? '0'.concat(p) : p,
          m = e.getSeconds(),
          v = m < 10 ? '0'.concat(m) : m,
          g = {
            H: ''.concat(u),
            HH: ''.concat(f),
            M: ''.concat(p),
            MM: ''.concat(h),
            d: ''.concat(i),
            dd: ''.concat(r),
            h: ''.concat(d),
            hh: ''.concat(c),
            m: ''.concat(o),
            mm: ''.concat(a),
            s: ''.concat(m),
            ss: ''.concat(v),
            yy: ''.concat(s),
            yyyy: ''.concat(l),
          };
        return n.replace(
          /d{1,4}|m{1,4}|yy(?:yy)?|([HhMs])\1?|"[^"]*"|'[^']*'/g,
          function (e) {
            return g[e] ? g[e] : e.slice(1, e.length - 1);
          },
        );
      };
    return (
      (_e.date = function () {
        return {
          validate: function (e) {
            if ('' === e.value) return { meta: { date: null }, valid: !0 };
            var o = Object.assign(
                {},
                {
                  format:
                    e.element && 'date' === e.element.getAttribute('type')
                      ? 'YYYY-MM-DD'
                      : 'MM/DD/YYYY',
                  message: '',
                },
                i(e.options),
              ),
              s = e.l10n ? e.l10n.date.default : o.message,
              l = { message: ''.concat(s), meta: { date: null }, valid: !1 },
              d = o.format.split(' '),
              c = d.length > 1 ? d[1] : null,
              u = d.length > 2 ? d[2] : null,
              f = e.value.split(' '),
              p = f[0],
              h = f.length > 1 ? f[1] : null,
              m = f.length > 2 ? f[2] : null;
            if (d.length !== f.length) return l;
            var v =
              o.separator ||
              (-1 !== p.indexOf('/')
                ? '/'
                : -1 !== p.indexOf('-')
                  ? '-'
                  : -1 !== p.indexOf('.')
                    ? '.'
                    : '/');
            if (null === v || -1 === p.indexOf(v)) return l;
            var g = p.split(v),
              y = d[0].split(v);
            if (g.length !== y.length) return l;
            var b = g[y.indexOf('YYYY')],
              E = g[y.indexOf('MM')],
              x = g[y.indexOf('DD')];
            if (
              !/^\d+$/.test(b) ||
              !/^\d+$/.test(E) ||
              !/^\d+$/.test(x) ||
              b.length > 4 ||
              E.length > 2 ||
              x.length > 2
            )
              return l;
            var V = parseInt(b, 10),
              A = parseInt(E, 10),
              w = parseInt(x, 10);
            if (!n(V, A, w)) return l;
            var F = new Date(V, A - 1, w);
            if (c) {
              var O = h.split(':');
              if (c.split(':').length !== O.length) return l;
              var C =
                  O.length > 0
                    ? O[0].length <= 2 && /^\d+$/.test(O[0])
                      ? parseInt(O[0], 10)
                      : -1
                    : 0,
                I =
                  O.length > 1
                    ? O[1].length <= 2 && /^\d+$/.test(O[1])
                      ? parseInt(O[1], 10)
                      : -1
                    : 0,
                _ =
                  O.length > 2
                    ? O[2].length <= 2 && /^\d+$/.test(O[2])
                      ? parseInt(O[2], 10)
                      : -1
                    : 0;
              if (-1 === C || -1 === I || -1 === _) return l;
              if (_ < 0 || _ > 60) return l;
              if (C < 0 || C >= 24 || (u && C > 12)) return l;
              if (I < 0 || I > 59) return l;
              (F.setHours(m && 'PM' === m.toUpperCase() && C < 12 ? C + 12 : C),
                F.setMinutes(I),
                F.setSeconds(_));
            }
            var H = 'function' == typeof o.min ? o.min() : o.min,
              S = H instanceof Date ? H : H ? r(H, y, v) : F,
              k = 'function' == typeof o.max ? o.max() : o.max,
              P = k instanceof Date ? k : k ? r(k, y, v) : F,
              j = H instanceof Date ? a(S, o.format) : H,
              N = k instanceof Date ? a(P, o.format) : k;
            switch (!0) {
              case !!j && !N:
                return {
                  message: t(e.l10n ? e.l10n.date.min : s, j),
                  meta: { date: F },
                  valid: F.getTime() >= S.getTime(),
                };
              case !!N && !j:
                return {
                  message: t(e.l10n ? e.l10n.date.max : s, N),
                  meta: { date: F },
                  valid: F.getTime() <= P.getTime(),
                };
              case !!N && !!j:
                return {
                  message: t(e.l10n ? e.l10n.date.range : s, [j, N]),
                  meta: { date: F },
                  valid:
                    F.getTime() <= P.getTime() && F.getTime() >= S.getTime(),
                };
              default:
                return { message: ''.concat(s), meta: { date: F }, valid: !0 };
            }
          },
        };
      }),
      _e
    );
  })();
  var He,
    Se = Ie.exports,
    ke = { exports: {} },
    Pe = {};
  ke.exports =
    (He ||
      ((He = 1),
      (Pe.different = function () {
        return {
          validate: function (e) {
            var t =
              'function' == typeof e.options.compare
                ? e.options.compare.call(this)
                : e.options.compare;
            return { valid: '' === t || e.value !== t };
          },
        };
      })),
    Pe);
  var je,
    Ne = ke.exports,
    Le = { exports: {} },
    Te = {};
  Le.exports =
    (je ||
      ((je = 1),
      (Te.digits = function () {
        return {
          validate: function (e) {
            return { valid: '' === e.value || /^\d+$/.test(e.value) };
          },
        };
      })),
    Te);
  var Me,
    De = Le.exports,
    Re = { exports: {} },
    ze = {};
  Re.exports = (function () {
    if (Me) return ze;
    Me = 1;
    var e = o.utils.removeUndefined,
      t =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
      n =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return (
      (ze.emailAddress = function () {
        return {
          validate: function (i) {
            if ('' === i.value) return { valid: !0 };
            var r = Object.assign(
                {},
                { multiple: !1, requireGlobalDomain: !1, separator: /[,;]/ },
                e(i.options),
              ),
              o = r.requireGlobalDomain ? n : t;
            if (!0 === r.multiple || 'true' === ''.concat(r.multiple)) {
              for (
                var a = r.separator || /[,;]/,
                  s = (function (e, t) {
                    for (
                      var n = e.split(/"/), i = n.length, r = [], o = '', a = 0;
                      a < i;
                      a++
                    )
                      if (a % 2 == 0) {
                        var s = n[a].split(t),
                          l = s.length;
                        if (1 === l) o += s[0];
                        else {
                          r.push(o + s[0]);
                          for (var d = 1; d < l - 1; d++) r.push(s[d]);
                          o = s[l - 1];
                        }
                      } else ((o += '"' + n[a]), a < i - 1 && (o += '"'));
                    return (r.push(o), r);
                  })(i.value, a),
                  l = s.length,
                  d = 0;
                d < l;
                d++
              )
                if (!o.test(s[d])) return { valid: !1 };
              return { valid: !0 };
            }
            return { valid: o.test(i.value) };
          },
        };
      }),
      ze
    );
  })();
  var Ue,
    Be = Re.exports,
    Ye = { exports: {} },
    qe = {};
  Ye.exports = (function () {
    if (Ue) return qe;
    Ue = 1;
    var e = function (e) {
      return -1 === e.indexOf('.') ? e : e.split('.').slice(0, -1).join('.');
    };
    return (
      (qe.file = function () {
        return {
          validate: function (t) {
            if ('' === t.value) return { valid: !0 };
            var n,
              i,
              r = t.options.extension
                ? t.options.extension
                    .toLowerCase()
                    .split(',')
                    .map(function (e) {
                      return e.trim();
                    })
                : [],
              o = t.options.type
                ? t.options.type
                    .toLowerCase()
                    .split(',')
                    .map(function (e) {
                      return e.trim();
                    })
                : [];
            if (window.File && window.FileList && window.FileReader) {
              var a = t.element.files,
                s = a.length,
                l = 0;
              if (
                t.options.maxFiles &&
                s > parseInt(''.concat(t.options.maxFiles), 10)
              )
                return { meta: { error: 'INVALID_MAX_FILES' }, valid: !1 };
              if (
                t.options.minFiles &&
                s < parseInt(''.concat(t.options.minFiles), 10)
              )
                return { meta: { error: 'INVALID_MIN_FILES' }, valid: !1 };
              for (var d = {}, c = 0; c < s; c++) {
                if (
                  ((l += a[c].size),
                  (d = {
                    ext: (n = a[c].name.substr(a[c].name.lastIndexOf('.') + 1)),
                    file: a[c],
                    size: a[c].size,
                    type: a[c].type,
                  }),
                  t.options.minSize &&
                    a[c].size < parseInt(''.concat(t.options.minSize), 10))
                )
                  return {
                    meta: Object.assign({}, { error: 'INVALID_MIN_SIZE' }, d),
                    valid: !1,
                  };
                if (
                  t.options.maxSize &&
                  a[c].size > parseInt(''.concat(t.options.maxSize), 10)
                )
                  return {
                    meta: Object.assign({}, { error: 'INVALID_MAX_SIZE' }, d),
                    valid: !1,
                  };
                if (r.length > 0 && -1 === r.indexOf(n.toLowerCase()))
                  return {
                    meta: Object.assign({}, { error: 'INVALID_EXTENSION' }, d),
                    valid: !1,
                  };
                if (
                  o.length > 0 &&
                  a[c].type &&
                  -1 === o.indexOf(a[c].type.toLowerCase())
                )
                  return {
                    meta: Object.assign({}, { error: 'INVALID_TYPE' }, d),
                    valid: !1,
                  };
                if (
                  t.options.validateFileName &&
                  !t.options.validateFileName(e(a[c].name))
                )
                  return {
                    meta: Object.assign({}, { error: 'INVALID_NAME' }, d),
                    valid: !1,
                  };
              }
              if (
                t.options.maxTotalSize &&
                l > parseInt(''.concat(t.options.maxTotalSize), 10)
              )
                return {
                  meta: Object.assign(
                    {},
                    { error: 'INVALID_MAX_TOTAL_SIZE', totalSize: l },
                    d,
                  ),
                  valid: !1,
                };
              if (
                t.options.minTotalSize &&
                l < parseInt(''.concat(t.options.minTotalSize), 10)
              )
                return {
                  meta: Object.assign(
                    {},
                    { error: 'INVALID_MIN_TOTAL_SIZE', totalSize: l },
                    d,
                  ),
                  valid: !1,
                };
            } else {
              if (
                ((n = t.value.substr(t.value.lastIndexOf('.') + 1)),
                r.length > 0 && -1 === r.indexOf(n.toLowerCase()))
              )
                return {
                  meta: { error: 'INVALID_EXTENSION', ext: n },
                  valid: !1,
                };
              if (
                ((i = e(t.value)),
                t.options.validateFileName && !t.options.validateFileName(i))
              )
                return { meta: { error: 'INVALID_NAME', name: i }, valid: !1 };
            }
            return { valid: !0 };
          },
        };
      }),
      qe
    );
  })();
  var Ge,
    Ze = Ye.exports,
    $e = { exports: {} },
    Xe = {};
  $e.exports = (function () {
    if (Ge) return Xe;
    Ge = 1;
    var e = o,
      t = e.utils.format,
      n = e.utils.removeUndefined;
    return (
      (Xe.greaterThan = function () {
        return {
          validate: function (e) {
            if ('' === e.value) return { valid: !0 };
            var i = Object.assign(
                {},
                { inclusive: !0, message: '' },
                n(e.options),
              ),
              r = parseFloat(''.concat(i.min).replace(',', '.'));
            return i.inclusive
              ? {
                  message: t(
                    e.l10n
                      ? i.message || e.l10n.greaterThan.default
                      : i.message,
                    ''.concat(r),
                  ),
                  valid: parseFloat(e.value) >= r,
                }
              : {
                  message: t(
                    e.l10n
                      ? i.message || e.l10n.greaterThan.notInclusive
                      : i.message,
                    ''.concat(r),
                  ),
                  valid: parseFloat(e.value) > r,
                };
          },
        };
      }),
      Xe
    );
  })();
  var Je,
    Ke = $e.exports,
    We = { exports: {} },
    Qe = {};
  We.exports =
    (Je ||
      ((Je = 1),
      (Qe.identical = function () {
        return {
          validate: function (e) {
            var t =
              'function' == typeof e.options.compare
                ? e.options.compare.call(this)
                : e.options.compare;
            return { valid: '' === t || e.value === t };
          },
        };
      })),
    Qe);
  var et,
    tt = We.exports,
    nt = { exports: {} },
    it = {};
  nt.exports = (function () {
    if (et) return it;
    et = 1;
    var e = o.utils.removeUndefined;
    return (
      (it.integer = function () {
        return {
          validate: function (t) {
            if ('' === t.value) return { valid: !0 };
            var n = Object.assign(
                {},
                { decimalSeparator: '.', thousandsSeparator: '' },
                e(t.options),
              ),
              i = '.' === n.decimalSeparator ? '\\.' : n.decimalSeparator,
              r = '.' === n.thousandsSeparator ? '\\.' : n.thousandsSeparator,
              o = new RegExp(
                '^-?[0-9]{1,3}('
                  .concat(r, '[0-9]{3})*(')
                  .concat(i, '[0-9]+)?$'),
              ),
              a = new RegExp(r, 'g'),
              s = ''.concat(t.value);
            if (!o.test(s)) return { valid: !1 };
            (r && (s = s.replace(a, '')), i && (s = s.replace(i, '.')));
            var l = parseFloat(s);
            return { valid: !isNaN(l) && isFinite(l) && Math.floor(l) === l };
          },
        };
      }),
      it
    );
  })();
  var rt,
    ot = nt.exports,
    at = { exports: {} },
    st = {};
  at.exports = (function () {
    if (rt) return st;
    rt = 1;
    var e = o.utils.removeUndefined;
    return (
      (st.ip = function () {
        return {
          validate: function (t) {
            if ('' === t.value) return { valid: !0 };
            var n = Object.assign({}, { ipv4: !0, ipv6: !0 }, e(t.options)),
              i =
                /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\/([0-9]|[1-2][0-9]|3[0-2]))?$/,
              r =
                /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*(\/(\d|\d\d|1[0-1]\d|12[0-8]))?$/;
            switch (!0) {
              case n.ipv4 && !n.ipv6:
                return {
                  message: t.l10n ? n.message || t.l10n.ip.ipv4 : n.message,
                  valid: i.test(t.value),
                };
              case !n.ipv4 && n.ipv6:
                return {
                  message: t.l10n ? n.message || t.l10n.ip.ipv6 : n.message,
                  valid: r.test(t.value),
                };
              case n.ipv4 && n.ipv6:
              default:
                return {
                  message: t.l10n ? n.message || t.l10n.ip.default : n.message,
                  valid: i.test(t.value) || r.test(t.value),
                };
            }
          },
        };
      }),
      st
    );
  })();
  var lt,
    dt = at.exports,
    ct = { exports: {} },
    ut = {};
  ct.exports = (function () {
    if (lt) return ut;
    lt = 1;
    var e = o,
      t = e.utils.format,
      n = e.utils.removeUndefined;
    return (
      (ut.lessThan = function () {
        return {
          validate: function (e) {
            if ('' === e.value) return { valid: !0 };
            var i = Object.assign(
                {},
                { inclusive: !0, message: '' },
                n(e.options),
              ),
              r = parseFloat(''.concat(i.max).replace(',', '.'));
            return i.inclusive
              ? {
                  message: t(
                    e.l10n ? i.message || e.l10n.lessThan.default : i.message,
                    ''.concat(r),
                  ),
                  valid: parseFloat(e.value) <= r,
                }
              : {
                  message: t(
                    e.l10n
                      ? i.message || e.l10n.lessThan.notInclusive
                      : i.message,
                    ''.concat(r),
                  ),
                  valid: parseFloat(e.value) < r,
                };
          },
        };
      }),
      ut
    );
  })();
  var ft,
    pt = ct.exports,
    ht = { exports: {} },
    mt = {};
  ht.exports =
    (ft ||
      ((ft = 1),
      (mt.notEmpty = function () {
        return {
          validate: function (e) {
            var t = !!e.options && !!e.options.trim,
              n = e.value;
            return {
              valid: (!t && '' !== n) || (t && '' !== n && '' !== n.trim()),
            };
          },
        };
      })),
    mt);
  var vt,
    gt = ht.exports,
    yt = { exports: {} },
    bt = {};
  yt.exports = (function () {
    if (vt) return bt;
    vt = 1;
    var e = o.utils.removeUndefined;
    return (
      (bt.numeric = function () {
        return {
          validate: function (t) {
            if ('' === t.value) return { valid: !0 };
            var n = Object.assign(
                {},
                { decimalSeparator: '.', thousandsSeparator: '' },
                e(t.options),
              ),
              i = ''.concat(t.value);
            i.substr(0, 1) === n.decimalSeparator
              ? (i = '0'.concat(n.decimalSeparator).concat(i.substr(1)))
              : i.substr(0, 2) === '-'.concat(n.decimalSeparator) &&
                (i = '-0'.concat(n.decimalSeparator).concat(i.substr(2)));
            var r = '.' === n.decimalSeparator ? '\\.' : n.decimalSeparator,
              o = '.' === n.thousandsSeparator ? '\\.' : n.thousandsSeparator,
              a = new RegExp(
                '^-?[0-9]{1,3}('
                  .concat(o, '[0-9]{3})*(')
                  .concat(r, '[0-9]+)?$'),
              ),
              s = new RegExp(o, 'g');
            if (!a.test(i)) return { valid: !1 };
            (o && (i = i.replace(s, '')), r && (i = i.replace(r, '.')));
            var l = parseFloat(i);
            return { valid: !isNaN(l) && isFinite(l) };
          },
        };
      }),
      bt
    );
  })();
  var Et,
    xt = yt.exports,
    Vt = { exports: {} },
    At = {};
  Vt.exports = (function () {
    if (Et) return At;
    Et = 1;
    var e = o.utils.call;
    return (
      (At.promise = function () {
        return {
          validate: function (t) {
            return e(t.options.promise, [t]);
          },
        };
      }),
      At
    );
  })();
  var wt,
    Ft = Vt.exports,
    Ot = { exports: {} },
    Ct = {};
  Ot.exports =
    (wt ||
      ((wt = 1),
      (Ct.regexp = function () {
        return {
          validate: function (e) {
            if ('' === e.value) return { valid: !0 };
            var t = e.options.regexp;
            if (t instanceof RegExp) return { valid: t.test(e.value) };
            var n = t.toString();
            return {
              valid: (e.options.flags
                ? new RegExp(n, e.options.flags)
                : new RegExp(n)
              ).test(e.value),
            };
          },
        };
      })),
    Ct);
  var It,
    _t = Ot.exports,
    Ht = { exports: {} },
    St = {};
  Ht.exports = (function () {
    if (It) return St;
    It = 1;
    var e = o,
      t = e.utils.fetch,
      n = e.utils.removeUndefined;
    return (
      (St.remote = function () {
        var e = {
          crossDomain: !1,
          data: {},
          headers: {},
          method: 'GET',
          validKey: 'valid',
        };
        return {
          validate: function (i) {
            if ('' === i.value) return Promise.resolve({ valid: !0 });
            var r = Object.assign({}, e, n(i.options)),
              o = r.data;
            ('function' == typeof r.data && (o = r.data.call(this, i)),
              'string' == typeof o && (o = JSON.parse(o)),
              (o[r.name || i.field] = i.value));
            var a = 'function' == typeof r.url ? r.url.call(this, i) : r.url;
            return t(a, {
              crossDomain: r.crossDomain,
              headers: r.headers,
              method: r.method,
              params: o,
            })
              .then(function (e) {
                return Promise.resolve({
                  message: e.message,
                  meta: e,
                  valid: 'true' === ''.concat(e[r.validKey]),
                });
              })
              .catch(function (e) {
                return Promise.reject({ valid: !1 });
              });
          },
        };
      }),
      St
    );
  })();
  var kt,
    Pt = Ht.exports,
    jt = { exports: {} },
    Nt = {};
  jt.exports = (function () {
    if (kt) return Nt;
    kt = 1;
    var e = o.utils.removeUndefined;
    return (
      (Nt.stringCase = function () {
        return {
          validate: function (t) {
            if ('' === t.value) return { valid: !0 };
            var n = Object.assign({}, { case: 'lower' }, e(t.options)),
              i = (n.case || 'lower').toLowerCase();
            return {
              message:
                n.message ||
                (t.l10n
                  ? 'upper' === i
                    ? t.l10n.stringCase.upper
                    : t.l10n.stringCase.default
                  : n.message),
              valid:
                'upper' === i
                  ? t.value === t.value.toUpperCase()
                  : t.value === t.value.toLowerCase(),
            };
          },
        };
      }),
      Nt
    );
  })();
  var Lt,
    Tt = jt.exports,
    Mt = { exports: {} },
    Dt = {};
  Mt.exports = (function () {
    if (Lt) return Dt;
    Lt = 1;
    var e = o,
      t = e.utils.format,
      n = e.utils.removeUndefined;
    return (
      (Dt.stringLength = function () {
        return {
          validate: function (e) {
            var i = Object.assign(
                {},
                { message: '', trim: !1, utf8Bytes: !1 },
                n(e.options),
              ),
              r =
                !0 === i.trim || 'true' === ''.concat(i.trim)
                  ? e.value.trim()
                  : e.value;
            if ('' === r) return { valid: !0 };
            var o = i.min ? ''.concat(i.min) : '',
              a = i.max ? ''.concat(i.max) : '',
              s = i.utf8Bytes
                ? (function (e) {
                    for (var t = e.length, n = e.length - 1; n >= 0; n--) {
                      var i = e.charCodeAt(n);
                      (i > 127 && i <= 2047
                        ? t++
                        : i > 2047 && i <= 65535 && (t += 2),
                        i >= 56320 && i <= 57343 && n--);
                    }
                    return t;
                  })(r)
                : r.length,
              l = !0,
              d = e.l10n ? i.message || e.l10n.stringLength.default : i.message;
            switch (
              (((o && s < parseInt(o, 10)) || (a && s > parseInt(a, 10))) &&
                (l = !1),
              !0)
            ) {
              case !!o && !!a:
                d = t(
                  e.l10n ? i.message || e.l10n.stringLength.between : i.message,
                  [o, a],
                );
                break;
              case !!o:
                d = t(
                  e.l10n ? i.message || e.l10n.stringLength.more : i.message,
                  ''.concat(parseInt(o, 10)),
                );
                break;
              case !!a:
                d = t(
                  e.l10n ? i.message || e.l10n.stringLength.less : i.message,
                  ''.concat(parseInt(a, 10)),
                );
            }
            return { message: d, valid: l };
          },
        };
      }),
      Dt
    );
  })();
  var Rt,
    zt = Mt.exports,
    Ut = { exports: {} },
    Bt = {};
  Ut.exports = (function () {
    if (Rt) return Bt;
    Rt = 1;
    var e = o.utils.removeUndefined;
    return (
      (Bt.uri = function () {
        var t = {
          allowEmptyProtocol: !1,
          allowLocal: !1,
          protocol: 'http, https, ftp',
        };
        return {
          validate: function (n) {
            if ('' === n.value) return { valid: !0 };
            var i = Object.assign({}, t, e(n.options)),
              r = !0 === i.allowLocal || 'true' === ''.concat(i.allowLocal),
              o =
                !0 === i.allowEmptyProtocol ||
                'true' === ''.concat(i.allowEmptyProtocol),
              a = i.protocol.split(',').join('|').replace(/\s/g, '');
            return {
              valid: new RegExp(
                '^(?:(?:' +
                  a +
                  ')://)' +
                  (o ? '?' : '') +
                  '(?:\\S+(?::\\S*)?@)?(?:' +
                  (r
                    ? ''
                    : '(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})') +
                  '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-?)*[a-z\\u00a1-\\uffff0-9])*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
                  (r ? '?' : '') +
                  ')(?::\\d{2,5})?(?:/[^\\s]*)?$',
                'i',
              ).test(n.value),
            };
          },
        };
      }),
      Bt
    );
  })();
  var Yt = Ut.exports,
    qt = {
      Alias: d.Alias,
      Aria: p.Aria,
      Declarative: g.Declarative,
      DefaultSubmit: x.DefaultSubmit,
      Dependency: F.Dependency,
      Excluded: _.Excluded,
      FieldStatus: P.FieldStatus,
      Framework: z.Framework,
      Icon: q.Icon,
      Message: D.Message,
      Sequence: X.Sequence,
      SubmitButton: Q.SubmitButton,
      Tooltip: ie.Tooltip,
      Trigger: se.Trigger,
    },
    Gt = {
      between: ue.between,
      blank: me.blank,
      callback: be.callback,
      choice: Ae.choice,
      creditCard: Ce.creditCard,
      date: Se.date,
      different: Ne.different,
      digits: De.digits,
      emailAddress: Be.emailAddress,
      file: Ze.file,
      greaterThan: Ke.greaterThan,
      identical: tt.identical,
      integer: ot.integer,
      ip: dt.ip,
      lessThan: pt.lessThan,
      notEmpty: gt.notEmpty,
      numeric: xt.numeric,
      promise: Ft.promise,
      regexp: _t.regexp,
      remote: Pt.remote,
      stringCase: Tt.stringCase,
      stringLength: zt.stringLength,
      uri: Yt.uri,
    };
  ((e.Plugin = o.Plugin),
    (e.algorithms = o.algorithms),
    (e.formValidation = function (e, t) {
      var n = o.formValidation(e, t);
      return (
        Object.keys(Gt).forEach(function (e) {
          return n.registerValidator(e, Gt[e]);
        }),
        n
      );
    }),
    (e.plugins = qt),
    (e.utils = o.utils),
    (e.validators = Gt));
});
